import React, { useEffect, useState, Component } from 'react';
import Layout from '../../components/Layout';
import { useParams, useNavigate } from 'react-router-dom';
import { BuildingIcon, MapPinIcon, UsersIcon, GraduationCapIcon, BarChart3Icon, AlertCircleIcon, CheckCircleIcon, XCircleIcon, TrendingUpIcon, CalendarIcon, ClockIcon, SearchIcon, FilterIcon, ChevronDownIcon, ArrowRightIcon, SparklesIcon, DownloadIcon, FileTextIcon, ExternalLinkIcon, FlagIcon, ShieldIcon, MailIcon, PhoneIcon, GlobeIcon } from 'lucide-react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, LineChart, Line } from 'recharts';
// Sample university data
const universitiesData = [{
  id: 1,
  name: 'UAE Business School',
  location: 'Dubai',
  programs: 12,
  activeApplications: 48,
  pendingReviews: 22,
  healthScore: 92,
  status: 'Active',
  lastUpdated: '2023-06-15',
  establishedYear: 1997,
  studentsEnrolled: 4850,
  accreditation: 'Ministry of Education, UAE',
  accreditationExpiry: '2026-08-15',
  accreditationStatus: 'Fully Accredited',
  accreditationHistory: [{
    date: '2021-08-15',
    status: 'Fully Accredited',
    notes: 'Renewed for 5 years'
  }, {
    date: '2016-08-20',
    status: 'Fully Accredited',
    notes: 'Renewed with commendations'
  }, {
    date: '2011-09-01',
    status: 'Provisionally Accredited',
    notes: 'Initial accreditation'
  }],
  intakePeriods: ['Fall 2023', 'Spring 2024'],
  programTypes: ["Bachelor's", "Master's", 'Doctorate'],
  flagged: false,
  contacts: {
    primary: {
      name: 'Dr. Ahmed Al Mansoori',
      title: 'Dean of Admissions',
      email: 'a.almansoori@ubschool.ae',
      phone: '+971 4 123 4567'
    },
    secondary: {
      name: 'Ms. Fatima Al Zaabi',
      title: 'Registrar',
      email: 'f.alzaabi@ubschool.ae',
      phone: '+971 4 123 4568'
    }
  },
  website: 'www.ubschool.ae',
  applicationTrends: [{
    month: 'Jan',
    applications: 25
  }, {
    month: 'Feb',
    applications: 30
  }, {
    month: 'Mar',
    applications: 28
  }, {
    month: 'Apr',
    applications: 35
  }, {
    month: 'May',
    applications: 42
  }, {
    month: 'Jun',
    applications: 48
  }],
  healthScoreHistory: [{
    quarter: 'Q1 2022',
    score: 84
  }, {
    quarter: 'Q2 2022',
    score: 86
  }, {
    quarter: 'Q3 2022',
    score: 88
  }, {
    quarter: 'Q4 2022',
    score: 90
  }, {
    quarter: 'Q1 2023',
    score: 91
  }, {
    quarter: 'Q2 2023',
    score: 92
  }],
  aiInsights: [{
    type: 'improvement',
    title: 'Program Completion Rate',
    message: 'MBA program has a 15% lower completion rate compared to similar programs.',
    severity: 'medium'
  }, {
    type: 'trend',
    title: 'Application Growth',
    message: 'Applications have grown 28% year-over-year, outpacing the sector average of 12%.',
    severity: 'positive'
  }, {
    type: 'alert',
    title: 'Document Verification',
    message: '8 applicant documents require verification before the intake deadline.',
    severity: 'high'
  }]
}, {
  id: 2,
  name: 'Emirates Institute of Technology',
  location: 'Abu Dhabi',
  programs: 24,
  activeApplications: 103,
  pendingReviews: 56,
  healthScore: 87,
  status: 'Active',
  lastUpdated: '2023-06-12',
  establishedYear: 2001,
  studentsEnrolled: 6200,
  accreditation: 'Ministry of Education, UAE',
  accreditationExpiry: '2025-05-10',
  accreditationStatus: 'Fully Accredited',
  accreditationHistory: [{
    date: '2020-05-10',
    status: 'Fully Accredited',
    notes: 'Renewed for 5 years'
  }, {
    date: '2015-05-15',
    status: 'Fully Accredited',
    notes: 'Renewed with recommendations'
  }, {
    date: '2010-06-01',
    status: 'Fully Accredited',
    notes: 'Initial accreditation'
  }],
  intakePeriods: ['Fall 2023', 'Spring 2024', 'Summer 2024'],
  programTypes: ["Bachelor's", "Master's", 'Diploma'],
  flagged: false,
  contacts: {
    primary: {
      name: 'Dr. Mohammed Al Hashimi',
      title: 'President',
      email: 'm.alhashimi@eit.ae',
      phone: '+971 2 987 6543'
    },
    secondary: {
      name: 'Mr. Khalid Al Suwaidi',
      title: 'Director of Admissions',
      email: 'k.alsuwaidi@eit.ae',
      phone: '+971 2 987 6544'
    }
  },
  website: 'www.eit.ae',
  applicationTrends: [{
    month: 'Jan',
    applications: 65
  }, {
    month: 'Feb',
    applications: 72
  }, {
    month: 'Mar',
    applications: 80
  }, {
    month: 'Apr',
    applications: 88
  }, {
    month: 'May',
    applications: 95
  }, {
    month: 'Jun',
    applications: 103
  }],
  healthScoreHistory: [{
    quarter: 'Q1 2022',
    score: 82
  }, {
    quarter: 'Q2 2022',
    score: 83
  }, {
    quarter: 'Q3 2022',
    score: 85
  }, {
    quarter: 'Q4 2022',
    score: 84
  }, {
    quarter: 'Q1 2023',
    score: 86
  }, {
    quarter: 'Q2 2023',
    score: 87
  }],
  aiInsights: [{
    type: 'improvement',
    title: 'Curriculum Alignment',
    message: 'Computer Science program curriculum shows 25% gap with current industry needs.',
    severity: 'high'
  }, {
    type: 'trend',
    title: 'Student Demographics',
    message: 'International student enrollment has increased by 35% in the last year.',
    severity: 'positive'
  }, {
    type: 'alert',
    title: 'Application Processing',
    message: '32 applications have been in review status for more than 14 days.',
    severity: 'medium'
  }]
}, {
  id: 3,
  name: 'Sharjah American University',
  location: 'Sharjah',
  programs: 18,
  activeApplications: 75,
  pendingReviews: 31,
  healthScore: 94,
  status: 'Active',
  lastUpdated: '2023-06-10',
  establishedYear: 1995,
  studentsEnrolled: 5100,
  accreditation: 'Ministry of Education, UAE',
  accreditationExpiry: '2024-09-30',
  accreditationStatus: 'Fully Accredited',
  accreditationHistory: [{
    date: '2019-09-30',
    status: 'Fully Accredited',
    notes: 'Renewed for 5 years'
  }, {
    date: '2014-10-15',
    status: 'Fully Accredited',
    notes: 'Renewed with commendations'
  }, {
    date: '2009-10-01',
    status: 'Fully Accredited',
    notes: 'Initial accreditation'
  }],
  intakePeriods: ['Fall 2023', 'Spring 2024'],
  programTypes: ["Bachelor's", "Master's", 'Doctorate'],
  flagged: false,
  contacts: {
    primary: {
      name: 'Dr. Sarah Johnson',
      title: 'President',
      email: 's.johnson@sau.ae',
      phone: '+971 6 555 1234'
    },
    secondary: {
      name: 'Mr. Omar Al Qasimi',
      title: 'Director of Admissions',
      email: 'o.alqasimi@sau.ae',
      phone: '+971 6 555 5678'
    }
  },
  website: 'www.sau.ae',
  applicationTrends: [{
    month: 'Jan',
    applications: 45
  }, {
    month: 'Feb',
    applications: 50
  }, {
    month: 'Mar',
    applications: 55
  }, {
    month: 'Apr',
    applications: 60
  }, {
    month: 'May',
    applications: 70
  }, {
    month: 'Jun',
    applications: 75
  }],
  healthScoreHistory: [{
    quarter: 'Q1 2022',
    score: 88
  }, {
    quarter: 'Q2 2022',
    score: 90
  }, {
    quarter: 'Q3 2022',
    score: 91
  }, {
    quarter: 'Q4 2022',
    score: 92
  }, {
    quarter: 'Q1 2023',
    score: 93
  }, {
    quarter: 'Q2 2023',
    score: 94
  }],
  aiInsights: [{
    type: 'improvement',
    title: 'International Enrollment',
    message: 'International student applications have increased by 25% this year.',
    severity: 'positive'
  }, {
    type: 'trend',
    title: 'Research Output',
    message: 'Research publications have increased by 18% compared to last year.',
    severity: 'positive'
  }, {
    type: 'alert',
    title: 'Scholarship Funding',
    message: 'Scholarship budget utilization is at 85%, consider allocating additional funds.',
    severity: 'medium'
  }]
}, {
  id: 4,
  name: 'Dubai Medical College',
  location: 'Dubai',
  programs: 8,
  activeApplications: 62,
  pendingReviews: 15,
  healthScore: 89,
  status: 'Under Review',
  lastUpdated: '2023-06-05',
  establishedYear: 2003,
  studentsEnrolled: 2350,
  accreditation: 'Ministry of Education, UAE',
  accreditationExpiry: '2023-12-31',
  accreditationStatus: 'Under Review',
  accreditationHistory: [{
    date: '2018-12-31',
    status: 'Fully Accredited',
    notes: 'Renewed for 5 years'
  }, {
    date: '2013-12-15',
    status: 'Fully Accredited',
    notes: 'Initial accreditation'
  }],
  intakePeriods: ['Fall 2023'],
  programTypes: ["Bachelor's", "Master's"],
  flagged: true,
  contacts: {
    primary: {
      name: 'Dr. Aisha Al Maktoum',
      title: 'Dean',
      email: 'a.almaktoum@dmc.ae',
      phone: '+971 4 987 1234'
    },
    secondary: {
      name: 'Ms. Layla Hassan',
      title: 'Admissions Coordinator',
      email: 'l.hassan@dmc.ae',
      phone: '+971 4 987 5678'
    }
  },
  website: 'www.dmc.ae',
  applicationTrends: [{
    month: 'Jan',
    applications: 35
  }, {
    month: 'Feb',
    applications: 40
  }, {
    month: 'Mar',
    applications: 45
  }, {
    month: 'Apr',
    applications: 50
  }, {
    month: 'May',
    applications: 55
  }, {
    month: 'Jun',
    applications: 62
  }],
  healthScoreHistory: [{
    quarter: 'Q1 2022',
    score: 82
  }, {
    quarter: 'Q2 2022',
    score: 84
  }, {
    quarter: 'Q3 2022',
    score: 85
  }, {
    quarter: 'Q4 2022',
    score: 87
  }, {
    quarter: 'Q1 2023',
    score: 88
  }, {
    quarter: 'Q2 2023',
    score: 89
  }],
  aiInsights: [{
    type: 'improvement',
    title: 'Clinical Placements',
    message: 'Clinical placement availability has decreased by 15% due to hospital policy changes.',
    severity: 'high'
  }, {
    type: 'trend',
    title: 'Graduation Rate',
    message: 'Medical program graduation rate is 8% below the national average.',
    severity: 'medium'
  }, {
    type: 'alert',
    title: 'Accreditation Review',
    message: 'Accreditation renewal documentation needs to be submitted within 60 days.',
    severity: 'high'
  }]
}, {
  id: 5,
  name: 'Abu Dhabi School of Management',
  location: 'Abu Dhabi',
  programs: 10,
  activeApplications: 42,
  pendingReviews: 18,
  healthScore: 81,
  status: 'Active',
  lastUpdated: '2023-06-08',
  establishedYear: 2006,
  studentsEnrolled: 1850,
  accreditation: 'Ministry of Education, UAE',
  accreditationExpiry: '2025-03-15',
  accreditationStatus: 'Fully Accredited',
  accreditationHistory: [{
    date: '2020-03-15',
    status: 'Fully Accredited',
    notes: 'Renewed for 5 years'
  }, {
    date: '2015-03-20',
    status: 'Fully Accredited',
    notes: 'Initial accreditation'
  }],
  intakePeriods: ['Fall 2023', 'Spring 2024'],
  programTypes: ["Bachelor's", "Master's"],
  flagged: true,
  contacts: {
    primary: {
      name: 'Dr. Khalid Al Nahyan',
      title: 'Director',
      email: 'k.alnahyan@adsm.ae',
      phone: '+971 2 444 5678'
    },
    secondary: {
      name: 'Mr. Tariq Al Marzouqi',
      title: 'Registrar',
      email: 't.almarzouqi@adsm.ae',
      phone: '+971 2 444 8765'
    }
  },
  website: 'www.adsm.ae',
  applicationTrends: [{
    month: 'Jan',
    applications: 20
  }, {
    month: 'Feb',
    applications: 25
  }, {
    month: 'Mar',
    applications: 30
  }, {
    month: 'Apr',
    applications: 35
  }, {
    month: 'May',
    applications: 40
  }, {
    month: 'Jun',
    applications: 42
  }],
  healthScoreHistory: [{
    quarter: 'Q1 2022',
    score: 76
  }, {
    quarter: 'Q2 2022',
    score: 77
  }, {
    quarter: 'Q3 2022',
    score: 78
  }, {
    quarter: 'Q4 2022',
    score: 79
  }, {
    quarter: 'Q1 2023',
    score: 80
  }, {
    quarter: 'Q2 2023',
    score: 81
  }],
  aiInsights: [{
    type: 'improvement',
    title: 'Student Retention',
    message: 'First-year student retention rate has dropped by 7% compared to previous year.',
    severity: 'high'
  }, {
    type: 'trend',
    title: 'Industry Partnerships',
    message: 'Corporate partnerships have increased by 15%, leading to more internship opportunities.',
    severity: 'positive'
  }, {
    type: 'alert',
    title: 'Program Review',
    message: 'MBA program curriculum needs updating to align with industry standards.',
    severity: 'medium'
  }]
}, {
  id: 6,
  name: 'Zayed University',
  location: 'Abu Dhabi',
  programs: 28,
  activeApplications: 118,
  pendingReviews: 43,
  healthScore: 95,
  status: 'Active',
  lastUpdated: '2023-06-07',
  establishedYear: 1998,
  studentsEnrolled: 8500,
  accreditation: 'Ministry of Education, UAE',
  accreditationExpiry: '2027-01-15',
  accreditationStatus: 'Fully Accredited',
  accreditationHistory: [{
    date: '2022-01-15',
    status: 'Fully Accredited',
    notes: 'Renewed for 5 years with distinction'
  }, {
    date: '2017-01-20',
    status: 'Fully Accredited',
    notes: 'Renewed with commendations'
  }, {
    date: '2012-02-01',
    status: 'Fully Accredited',
    notes: 'Renewed with minor recommendations'
  }, {
    date: '2007-02-15',
    status: 'Fully Accredited',
    notes: 'Initial accreditation'
  }],
  intakePeriods: ['Fall 2023', 'Spring 2024', 'Summer 2024'],
  programTypes: ["Bachelor's", "Master's", 'Doctorate'],
  flagged: false,
  contacts: {
    primary: {
      name: 'Dr. Noura Al Kaabi',
      title: 'President',
      email: 'n.alkaabi@zu.ae',
      phone: '+971 2 599 3333'
    },
    secondary: {
      name: 'Dr. Mariam Al Shamsi',
      title: 'Vice President of Academic Affairs',
      email: 'm.alshamsi@zu.ae',
      phone: '+971 2 599 4444'
    }
  },
  website: 'www.zu.ae',
  applicationTrends: [{
    month: 'Jan',
    applications: 70
  }, {
    month: 'Feb',
    applications: 80
  }, {
    month: 'Mar',
    applications: 90
  }, {
    month: 'Apr',
    applications: 100
  }, {
    month: 'May',
    applications: 110
  }, {
    month: 'Jun',
    applications: 118
  }],
  healthScoreHistory: [{
    quarter: 'Q1 2022',
    score: 91
  }, {
    quarter: 'Q2 2022',
    score: 92
  }, {
    quarter: 'Q3 2022',
    score: 93
  }, {
    quarter: 'Q4 2022',
    score: 94
  }, {
    quarter: 'Q1 2023',
    score: 94
  }, {
    quarter: 'Q2 2023',
    score: 95
  }],
  aiInsights: [{
    type: 'improvement',
    title: 'Research Funding',
    message: 'Research grant funding has increased by 30% compared to previous year.',
    severity: 'positive'
  }, {
    type: 'trend',
    title: 'Graduate Employment',
    message: '92% of graduates secured employment within 6 months, exceeding national average.',
    severity: 'positive'
  }, {
    type: 'alert',
    title: 'Facility Expansion',
    message: 'Campus expansion project is behind schedule by 2 months, may impact Fall intake.',
    severity: 'medium'
  }]
}, {
  id: 7,
  name: 'Ajman University',
  location: 'Ajman',
  programs: 16,
  activeApplications: 68,
  pendingReviews: 24,
  healthScore: 88,
  status: 'Active',
  lastUpdated: '2023-06-09',
  establishedYear: 1999,
  studentsEnrolled: 4200,
  accreditation: 'Ministry of Education, UAE',
  accreditationExpiry: '2025-08-10',
  accreditationStatus: 'Fully Accredited',
  accreditationHistory: [{
    date: '2020-08-10',
    status: 'Fully Accredited',
    notes: 'Renewed for 5 years'
  }, {
    date: '2015-08-15',
    status: 'Fully Accredited',
    notes: 'Renewed with recommendations'
  }, {
    date: '2010-09-01',
    status: 'Fully Accredited',
    notes: 'Initial accreditation'
  }],
  intakePeriods: ['Fall 2023', 'Spring 2024'],
  programTypes: ["Bachelor's", "Master's"],
  flagged: false,
  contacts: {
    primary: {
      name: 'Dr. Karim Al Nuaimi',
      title: 'Chancellor',
      email: 'k.alnuaimi@ajman.ae',
      phone: '+971 6 748 1111'
    },
    secondary: {
      name: 'Ms. Hind Al Ali',
      title: 'Director of Enrollment',
      email: 'h.alali@ajman.ae',
      phone: '+971 6 748 2222'
    }
  },
  website: 'www.ajman.ae',
  applicationTrends: [{
    month: 'Jan',
    applications: 40
  }, {
    month: 'Feb',
    applications: 45
  }, {
    month: 'Mar',
    applications: 50
  }, {
    month: 'Apr',
    applications: 55
  }, {
    month: 'May',
    applications: 60
  }, {
    month: 'Jun',
    applications: 68
  }],
  healthScoreHistory: [{
    quarter: 'Q1 2022',
    score: 83
  }, {
    quarter: 'Q2 2022',
    score: 84
  }, {
    quarter: 'Q3 2022',
    score: 85
  }, {
    quarter: 'Q4 2022',
    score: 86
  }, {
    quarter: 'Q1 2023',
    score: 87
  }, {
    quarter: 'Q2 2023',
    score: 88
  }],
  aiInsights: [{
    type: 'improvement',
    title: 'Student Satisfaction',
    message: 'Student satisfaction scores have improved by 12% after facility upgrades.',
    severity: 'positive'
  }, {
    type: 'trend',
    title: 'Program Popularity',
    message: 'Engineering programs have seen a 20% increase in applications year-over-year.',
    severity: 'positive'
  }, {
    type: 'alert',
    title: 'Faculty Recruitment',
    message: '5 faculty positions remain unfilled with less than 60 days until Fall semester.',
    severity: 'medium'
  }]
}, {
  id: 8,
  name: 'RAK Medical & Health Sciences University',
  location: 'Ras Al Khaimah',
  programs: 6,
  activeApplications: 45,
  pendingReviews: 12,
  healthScore: 85,
  status: 'Under Review',
  lastUpdated: '2023-06-03',
  establishedYear: 2006,
  studentsEnrolled: 1200,
  accreditation: 'Ministry of Education, UAE',
  accreditationExpiry: '2024-05-20',
  accreditationStatus: 'Under Review',
  accreditationHistory: [{
    date: '2019-05-20',
    status: 'Fully Accredited',
    notes: 'Renewed for 5 years'
  }, {
    date: '2014-05-25',
    status: 'Provisionally Accredited',
    notes: 'Initial accreditation with conditions'
  }],
  intakePeriods: ['Fall 2023'],
  programTypes: ["Bachelor's", "Master's"],
  flagged: true,
  contacts: {
    primary: {
      name: 'Dr. Hassan Al Qasimi',
      title: 'President',
      email: 'h.alqasimi@rakmhsu.ae',
      phone: '+971 7 226 9999'
    },
    secondary: {
      name: 'Dr. Fatima Al Blooshi',
      title: 'Dean of Admissions',
      email: 'f.alblooshi@rakmhsu.ae',
      phone: '+971 7 226 8888'
    }
  },
  website: 'www.rakmhsu.ae',
  applicationTrends: [{
    month: 'Jan',
    applications: 25
  }, {
    month: 'Feb',
    applications: 30
  }, {
    month: 'Mar',
    applications: 35
  }, {
    month: 'Apr',
    applications: 38
  }, {
    month: 'May',
    applications: 42
  }, {
    month: 'Jun',
    applications: 45
  }],
  healthScoreHistory: [{
    quarter: 'Q1 2022',
    score: 80
  }, {
    quarter: 'Q2 2022',
    score: 81
  }, {
    quarter: 'Q3 2022',
    score: 82
  }, {
    quarter: 'Q4 2022',
    score: 83
  }, {
    quarter: 'Q1 2023',
    score: 84
  }, {
    quarter: 'Q2 2023',
    score: 85
  }],
  aiInsights: [{
    type: 'improvement',
    title: 'Clinical Training',
    message: 'Clinical training partnerships need expansion to accommodate growing student numbers.',
    severity: 'high'
  }, {
    type: 'trend',
    title: 'Research Output',
    message: 'Medical research publications have decreased by 10% compared to previous year.',
    severity: 'medium'
  }, {
    type: 'alert',
    title: 'Accreditation Status',
    message: 'Nursing program accreditation review requires immediate attention to address concerns.',
    severity: 'high'
  }]
}];
// Sample programs data
const programsData = [
// UAE Business School (universityId: 1) programs
{
  id: 1,
  name: 'Master of Business Administration',
  university: 'UAE Business School',
  universityId: 1,
  type: "Master's",
  duration: '2 Years',
  applications: 48,
  trend: '+12%',
  status: 'Active',
  skillGap: 'Low',
  nextIntake: 'Fall 2023',
  lastUpdated: '2023-06-15'
}, {
  id: 3,
  name: 'Master of Public Administration',
  university: 'UAE Business School',
  universityId: 1,
  type: "Master's",
  duration: '2 Years',
  applications: 27,
  trend: '-5%',
  status: 'Active',
  skillGap: 'High',
  nextIntake: 'Spring 2024',
  lastUpdated: '2023-06-10'
}, {
  id: 9,
  name: 'Bachelor of Business Administration',
  university: 'UAE Business School',
  universityId: 1,
  type: "Bachelor's",
  duration: '4 Years',
  applications: 65,
  trend: '+8%',
  status: 'Active',
  skillGap: 'Medium',
  nextIntake: 'Fall 2023',
  lastUpdated: '2023-06-08'
}, {
  id: 10,
  name: 'PhD in Business Analytics',
  university: 'UAE Business School',
  universityId: 1,
  type: 'Doctorate',
  duration: '3 Years',
  applications: 12,
  trend: '+15%',
  status: 'Under Review',
  skillGap: 'Low',
  nextIntake: 'Spring 2024',
  lastUpdated: '2023-06-05'
}, {
  id: 11,
  name: 'Bachelor of Finance',
  university: 'UAE Business School',
  universityId: 1,
  type: "Bachelor's",
  duration: '4 Years',
  applications: 38,
  trend: '+5%',
  status: 'Active',
  skillGap: 'Medium',
  nextIntake: 'Fall 2023',
  lastUpdated: '2023-06-12'
}, {
  id: 12,
  name: 'Master of Marketing',
  university: 'UAE Business School',
  universityId: 1,
  type: "Master's",
  duration: '2 Years',
  applications: 32,
  trend: '+18%',
  status: 'Active',
  skillGap: 'Medium',
  nextIntake: 'Fall 2023',
  lastUpdated: '2023-06-14'
}, {
  id: 13,
  name: 'Bachelor of Accounting',
  university: 'UAE Business School',
  universityId: 1,
  type: "Bachelor's",
  duration: '4 Years',
  applications: 42,
  trend: '+3%',
  status: 'Active',
  skillGap: 'Low',
  nextIntake: 'Fall 2023',
  lastUpdated: '2023-06-11'
}, {
  id: 14,
  name: 'Master of Finance',
  university: 'UAE Business School',
  universityId: 1,
  type: "Master's",
  duration: '2 Years',
  applications: 29,
  trend: '+7%',
  status: 'Active',
  skillGap: 'Medium',
  nextIntake: 'Spring 2024',
  lastUpdated: '2023-06-09'
}, {
  id: 15,
  name: 'PhD in Economics',
  university: 'UAE Business School',
  universityId: 1,
  type: 'Doctorate',
  duration: '3 Years',
  applications: 8,
  trend: '-2%',
  status: 'Under Review',
  skillGap: 'High',
  nextIntake: 'Fall 2023',
  lastUpdated: '2023-06-07'
}, {
  id: 16,
  name: 'Bachelor of International Business',
  university: 'UAE Business School',
  universityId: 1,
  type: "Bachelor's",
  duration: '4 Years',
  applications: 51,
  trend: '+15%',
  status: 'Active',
  skillGap: 'Low',
  nextIntake: 'Fall 2023',
  lastUpdated: '2023-06-13'
}, {
  id: 17,
  name: 'Executive MBA',
  university: 'UAE Business School',
  universityId: 1,
  type: "Master's",
  duration: '1.5 Years',
  applications: 36,
  trend: '+22%',
  status: 'Active',
  skillGap: 'Low',
  nextIntake: 'Spring 2024',
  lastUpdated: '2023-06-16'
},
// Emirates Institute of Technology (universityId: 2) programs
{
  id: 2,
  name: 'Bachelor of Computer Science',
  university: 'Emirates Institute of Technology',
  universityId: 2,
  type: "Bachelor's",
  duration: '4 Years',
  applications: 112,
  trend: '+28%',
  status: 'Active',
  skillGap: 'Medium',
  nextIntake: 'Fall 2023',
  lastUpdated: '2023-06-12'
}, {
  id: 4,
  name: 'PhD in Data Science',
  university: 'Emirates Institute of Technology',
  universityId: 2,
  type: 'Doctorate',
  duration: '3 Years',
  applications: 15,
  trend: '+8%',
  status: 'Active',
  skillGap: 'Low',
  nextIntake: 'Spring 2024',
  lastUpdated: '2023-06-11'
}, {
  id: 18,
  name: 'Master of Computer Science',
  university: 'Emirates Institute of Technology',
  universityId: 2,
  type: "Master's",
  duration: '2 Years',
  applications: 67,
  trend: '+32%',
  status: 'Active',
  skillGap: 'Low',
  nextIntake: 'Fall 2023',
  lastUpdated: '2023-06-15'
}, {
  id: 19,
  name: 'Bachelor of Cybersecurity',
  university: 'Emirates Institute of Technology',
  universityId: 2,
  type: "Bachelor's",
  duration: '4 Years',
  applications: 89,
  trend: '+45%',
  status: 'Active',
  skillGap: 'Critical',
  nextIntake: 'Fall 2023',
  lastUpdated: '2023-06-14'
}, {
  id: 20,
  name: 'Master of Artificial Intelligence',
  university: 'Emirates Institute of Technology',
  universityId: 2,
  type: "Master's",
  duration: '2 Years',
  applications: 58,
  trend: '+38%',
  status: 'Active',
  skillGap: 'High',
  nextIntake: 'Spring 2024',
  lastUpdated: '2023-06-13'
}, {
  id: 21,
  name: 'Bachelor of Software Engineering',
  university: 'Emirates Institute of Technology',
  universityId: 2,
  type: "Bachelor's",
  duration: '4 Years',
  applications: 95,
  trend: '+25%',
  status: 'Active',
  skillGap: 'Medium',
  nextIntake: 'Fall 2023',
  lastUpdated: '2023-06-12'
}, {
  id: 22,
  name: 'Master of Information Systems',
  university: 'Emirates Institute of Technology',
  universityId: 2,
  type: "Master's",
  duration: '2 Years',
  applications: 42,
  trend: '+15%',
  status: 'Active',
  skillGap: 'Medium',
  nextIntake: 'Fall 2023',
  lastUpdated: '2023-06-11'
}, {
  id: 23,
  name: 'PhD in Cybersecurity',
  university: 'Emirates Institute of Technology',
  universityId: 2,
  type: 'Doctorate',
  duration: '3 Years',
  applications: 12,
  trend: '+20%',
  status: 'Under Review',
  skillGap: 'High',
  nextIntake: 'Spring 2024',
  lastUpdated: '2023-06-10'
}, {
  id: 24,
  name: 'Bachelor of Network Engineering',
  university: 'Emirates Institute of Technology',
  universityId: 2,
  type: "Bachelor's",
  duration: '4 Years',
  applications: 76,
  trend: '+18%',
  status: 'Active',
  skillGap: 'Medium',
  nextIntake: 'Fall 2023',
  lastUpdated: '2023-06-09'
}, {
  id: 25,
  name: 'Master of Data Analytics',
  university: 'Emirates Institute of Technology',
  universityId: 2,
  type: "Master's",
  duration: '2 Years',
  applications: 53,
  trend: '+30%',
  status: 'Active',
  skillGap: 'Medium',
  nextIntake: 'Spring 2024',
  lastUpdated: '2023-06-08'
}, {
  id: 26,
  name: 'Bachelor of Information Technology',
  university: 'Emirates Institute of Technology',
  universityId: 2,
  type: "Bachelor's",
  duration: '4 Years',
  applications: 82,
  trend: '+22%',
  status: 'Active',
  skillGap: 'Low',
  nextIntake: 'Fall 2023',
  lastUpdated: '2023-06-07'
},
// Sharjah American University (universityId: 3) programs
{
  id: 27,
  name: 'Bachelor of Business Administration',
  university: 'Sharjah American University',
  universityId: 3,
  type: "Bachelor's",
  duration: '4 Years',
  applications: 78,
  trend: '+15%',
  status: 'Active',
  skillGap: 'Low',
  nextIntake: 'Fall 2023',
  lastUpdated: '2023-06-15'
}, {
  id: 28,
  name: 'Master of Education',
  university: 'Sharjah American University',
  universityId: 3,
  type: "Master's",
  duration: '2 Years',
  applications: 45,
  trend: '+8%',
  status: 'Active',
  skillGap: 'Medium',
  nextIntake: 'Spring 2024',
  lastUpdated: '2023-06-14'
}, {
  id: 29,
  name: 'Bachelor of Psychology',
  university: 'Sharjah American University',
  universityId: 3,
  type: "Bachelor's",
  duration: '4 Years',
  applications: 62,
  trend: '+12%',
  status: 'Active',
  skillGap: 'Low',
  nextIntake: 'Fall 2023',
  lastUpdated: '2023-06-13'
}, {
  id: 30,
  name: 'PhD in International Relations',
  university: 'Sharjah American University',
  universityId: 3,
  type: 'Doctorate',
  duration: '3 Years',
  applications: 18,
  trend: '+5%',
  status: 'Active',
  skillGap: 'Medium',
  nextIntake: 'Fall 2023',
  lastUpdated: '2023-06-12'
}, {
  id: 31,
  name: 'Master of International Business',
  university: 'Sharjah American University',
  universityId: 3,
  type: "Master's",
  duration: '2 Years',
  applications: 52,
  trend: '+18%',
  status: 'Active',
  skillGap: 'Medium',
  nextIntake: 'Spring 2024',
  lastUpdated: '2023-06-11'
}, {
  id: 32,
  name: 'Bachelor of Communications',
  university: 'Sharjah American University',
  universityId: 3,
  type: "Bachelor's",
  duration: '4 Years',
  applications: 56,
  trend: '+10%',
  status: 'Active',
  skillGap: 'Low',
  nextIntake: 'Fall 2023',
  lastUpdated: '2023-06-10'
}, {
  id: 33,
  name: 'Master of Public Health',
  university: 'Sharjah American University',
  universityId: 3,
  type: "Master's",
  duration: '2 Years',
  applications: 38,
  trend: '+22%',
  status: 'Active',
  skillGap: 'High',
  nextIntake: 'Fall 2023',
  lastUpdated: '2023-06-09'
}, {
  id: 34,
  name: 'Bachelor of Architecture',
  university: 'Sharjah American University',
  universityId: 3,
  type: "Bachelor's",
  duration: '5 Years',
  applications: 48,
  trend: '+7%',
  status: 'Active',
  skillGap: 'Medium',
  nextIntake: 'Fall 2023',
  lastUpdated: '2023-06-08'
}, {
  id: 35,
  name: 'PhD in Urban Planning',
  university: 'Sharjah American University',
  universityId: 3,
  type: 'Doctorate',
  duration: '3 Years',
  applications: 14,
  trend: '+3%',
  status: 'Under Review',
  skillGap: 'Medium',
  nextIntake: 'Spring 2024',
  lastUpdated: '2023-06-07'
}, {
  id: 36,
  name: 'Master of Fine Arts',
  university: 'Sharjah American University',
  universityId: 3,
  type: "Master's",
  duration: '2 Years',
  applications: 32,
  trend: '+5%',
  status: 'Active',
  skillGap: 'Low',
  nextIntake: 'Fall 2023',
  lastUpdated: '2023-06-06'
},
// Dubai Medical College (universityId: 4) programs
{
  id: 5,
  name: 'Bachelor of Nursing',
  university: 'Dubai Medical College',
  universityId: 4,
  type: "Bachelor's",
  duration: '4 Years',
  applications: 62,
  trend: '+18%',
  status: 'Active',
  skillGap: 'Critical',
  nextIntake: 'Fall 2023',
  lastUpdated: '2023-06-05'
}, {
  id: 37,
  name: 'Doctor of Medicine',
  university: 'Dubai Medical College',
  universityId: 4,
  type: 'Doctorate',
  duration: '4 Years',
  applications: 85,
  trend: '+12%',
  status: 'Active',
  skillGap: 'High',
  nextIntake: 'Fall 2023',
  lastUpdated: '2023-06-15'
}, {
  id: 38,
  name: 'Bachelor of Pharmacy',
  university: 'Dubai Medical College',
  universityId: 4,
  type: "Bachelor's",
  duration: '4 Years',
  applications: 58,
  trend: '+15%',
  status: 'Active',
  skillGap: 'High',
  nextIntake: 'Fall 2023',
  lastUpdated: '2023-06-14'
}, {
  id: 39,
  name: 'Master of Public Health',
  university: 'Dubai Medical College',
  universityId: 4,
  type: "Master's",
  duration: '2 Years',
  applications: 42,
  trend: '+25%',
  status: 'Active',
  skillGap: 'Medium',
  nextIntake: 'Spring 2024',
  lastUpdated: '2023-06-13'
}, {
  id: 40,
  name: 'Bachelor of Medical Laboratory Sciences',
  university: 'Dubai Medical College',
  universityId: 4,
  type: "Bachelor's",
  duration: '4 Years',
  applications: 48,
  trend: '+10%',
  status: 'Active',
  skillGap: 'High',
  nextIntake: 'Fall 2023',
  lastUpdated: '2023-06-12'
}, {
  id: 41,
  name: 'Master of Nursing',
  university: 'Dubai Medical College',
  universityId: 4,
  type: "Master's",
  duration: '2 Years',
  applications: 35,
  trend: '+28%',
  status: 'Active',
  skillGap: 'Critical',
  nextIntake: 'Spring 2024',
  lastUpdated: '2023-06-11'
}, {
  id: 42,
  name: 'PhD in Pharmaceutical Sciences',
  university: 'Dubai Medical College',
  universityId: 4,
  type: 'Doctorate',
  duration: '3 Years',
  applications: 15,
  trend: '+8%',
  status: 'Under Review',
  skillGap: 'Medium',
  nextIntake: 'Fall 2023',
  lastUpdated: '2023-06-10'
}, {
  id: 43,
  name: 'Bachelor of Physiotherapy',
  university: 'Dubai Medical College',
  universityId: 4,
  type: "Bachelor's",
  duration: '4 Years',
  applications: 52,
  trend: '+20%',
  status: 'Active',
  skillGap: 'High',
  nextIntake: 'Fall 2023',
  lastUpdated: '2023-06-09'
}, {
  id: 44,
  name: 'Master of Clinical Psychology',
  university: 'Dubai Medical College',
  universityId: 4,
  type: "Master's",
  duration: '2 Years',
  applications: 28,
  trend: '+15%',
  status: 'Active',
  skillGap: 'Medium',
  nextIntake: 'Spring 2024',
  lastUpdated: '2023-06-08'
}, {
  id: 45,
  name: 'Bachelor of Dental Surgery',
  university: 'Dubai Medical College',
  universityId: 4,
  type: "Bachelor's",
  duration: '5 Years',
  applications: 68,
  trend: '+18%',
  status: 'Active',
  skillGap: 'High',
  nextIntake: 'Fall 2023',
  lastUpdated: '2023-06-07'
},
// Abu Dhabi School of Management (universityId: 5) programs
{
  id: 46,
  name: 'Master of Business Administration',
  university: 'Abu Dhabi School of Management',
  universityId: 5,
  type: "Master's",
  duration: '2 Years',
  applications: 45,
  trend: '+5%',
  status: 'Active',
  skillGap: 'Low',
  nextIntake: 'Fall 2023',
  lastUpdated: '2023-06-15'
}, {
  id: 47,
  name: 'Bachelor of Business Management',
  university: 'Abu Dhabi School of Management',
  universityId: 5,
  type: "Bachelor's",
  duration: '4 Years',
  applications: 52,
  trend: '+8%',
  status: 'Active',
  skillGap: 'Medium',
  nextIntake: 'Fall 2023',
  lastUpdated: '2023-06-14'
}, {
  id: 48,
  name: 'Master of Finance',
  university: 'Abu Dhabi School of Management',
  universityId: 5,
  type: "Master's",
  duration: '2 Years',
  applications: 38,
  trend: '+3%',
  status: 'Active',
  skillGap: 'Low',
  nextIntake: 'Spring 2024',
  lastUpdated: '2023-06-13'
}, {
  id: 49,
  name: 'Bachelor of Marketing',
  university: 'Abu Dhabi School of Management',
  universityId: 5,
  type: "Bachelor's",
  duration: '4 Years',
  applications: 48,
  trend: '+10%',
  status: 'Active',
  skillGap: 'Medium',
  nextIntake: 'Fall 2023',
  lastUpdated: '2023-06-12'
}, {
  id: 50,
  name: 'Master of Human Resources Management',
  university: 'Abu Dhabi School of Management',
  universityId: 5,
  type: "Master's",
  duration: '2 Years',
  applications: 32,
  trend: '+7%',
  status: 'Active',
  skillGap: 'High',
  nextIntake: 'Spring 2024',
  lastUpdated: '2023-06-11'
}, {
  id: 51,
  name: 'Bachelor of Accounting',
  university: 'Abu Dhabi School of Management',
  universityId: 5,
  type: "Bachelor's",
  duration: '4 Years',
  applications: 42,
  trend: '+5%',
  status: 'Active',
  skillGap: 'Low',
  nextIntake: 'Fall 2023',
  lastUpdated: '2023-06-10'
}, {
  id: 52,
  name: 'Executive MBA',
  university: 'Abu Dhabi School of Management',
  universityId: 5,
  type: "Master's",
  duration: '1.5 Years',
  applications: 35,
  trend: '+12%',
  status: 'Active',
  skillGap: 'Low',
  nextIntake: 'Fall 2023',
  lastUpdated: '2023-06-09'
}, {
  id: 53,
  name: 'Bachelor of International Business',
  university: 'Abu Dhabi School of Management',
  universityId: 5,
  type: "Bachelor's",
  duration: '4 Years',
  applications: 38,
  trend: '+6%',
  status: 'Active',
  skillGap: 'Medium',
  nextIntake: 'Fall 2023',
  lastUpdated: '2023-06-08'
}, {
  id: 54,
  name: 'Master of Project Management',
  university: 'Abu Dhabi School of Management',
  universityId: 5,
  type: "Master's",
  duration: '2 Years',
  applications: 28,
  trend: '+4%',
  status: 'Under Review',
  skillGap: 'Medium',
  nextIntake: 'Spring 2024',
  lastUpdated: '2023-06-07'
}, {
  id: 55,
  name: 'PhD in Business Management',
  university: 'Abu Dhabi School of Management',
  universityId: 5,
  type: 'Doctorate',
  duration: '3 Years',
  applications: 12,
  trend: '-2%',
  status: 'Under Review',
  skillGap: 'High',
  nextIntake: 'Fall 2023',
  lastUpdated: '2023-06-06'
}];
// Sample applications data
const applicationsData = [
// UAE Business School (universityId: 1) applications - 50 entries
{
  id: 101,
  studentName: 'Sarah Ahmed',
  program: 'Master of Business Administration',
  programId: 1,
  status: 'Pending',
  submissionDate: '2023-06-15',
  eligibility: 'Eligible',
  universityId: 1
}, {
  id: 102,
  studentName: 'Mohammed Al Farsi',
  program: 'Bachelor of Business Administration',
  programId: 9,
  status: 'Under Review',
  submissionDate: '2023-06-12',
  eligibility: 'Needs Review',
  universityId: 1
}, {
  id: 103,
  studentName: 'Fatima Al Zaabi',
  program: 'Master of Public Administration',
  programId: 3,
  status: 'Accepted',
  submissionDate: '2023-06-10',
  eligibility: 'Eligible',
  universityId: 1
}, {
  id: 104,
  studentName: 'Ahmed Al Mansoori',
  program: 'PhD in Business Analytics',
  programId: 10,
  status: 'Pending',
  submissionDate: '2023-06-08',
  eligibility: 'Eligible',
  universityId: 1
}, {
  id: 105,
  studentName: 'Noura Al Marzooqi',
  program: 'Master of Business Administration',
  programId: 1,
  status: 'Rejected',
  submissionDate: '2023-06-05',
  eligibility: 'Ineligible',
  universityId: 1
}, {
  id: 151,
  studentName: 'Khalid Al Shamsi',
  program: 'Bachelor of Finance',
  programId: 11,
  status: 'Accepted',
  submissionDate: '2023-06-14',
  eligibility: 'Eligible',
  universityId: 1
}, {
  id: 152,
  studentName: 'Aisha Al Hashemi',
  program: 'Master of Marketing',
  programId: 12,
  status: 'Pending',
  submissionDate: '2023-06-13',
  eligibility: 'Eligible',
  universityId: 1
}, {
  id: 153,
  studentName: 'Omar Al Nuaimi',
  program: 'Bachelor of Accounting',
  programId: 13,
  status: 'Under Review',
  submissionDate: '2023-06-12',
  eligibility: 'Needs Review',
  universityId: 1
}, {
  id: 154,
  studentName: 'Latifa Al Maktoum',
  program: 'Master of Finance',
  programId: 14,
  status: 'Accepted',
  submissionDate: '2023-06-11',
  eligibility: 'Eligible',
  universityId: 1
}, {
  id: 155,
  studentName: 'Saeed Al Dhaheri',
  program: 'PhD in Economics',
  programId: 15,
  status: 'Pending',
  submissionDate: '2023-06-10',
  eligibility: 'Eligible',
  universityId: 1
}, {
  id: 156,
  studentName: 'Mariam Al Suwaidi',
  program: 'Bachelor of International Business',
  programId: 16,
  status: 'Accepted',
  submissionDate: '2023-06-09',
  eligibility: 'Eligible',
  universityId: 1
}, {
  id: 157,
  studentName: 'Hamad Al Falasi',
  program: 'Executive MBA',
  programId: 17,
  status: 'Under Review',
  submissionDate: '2023-06-08',
  eligibility: 'Needs Review',
  universityId: 1
}, {
  id: 158,
  studentName: 'Reem Al Qasimi',
  program: 'Master of Business Administration',
  programId: 1,
  status: 'Accepted',
  submissionDate: '2023-06-07',
  eligibility: 'Eligible',
  universityId: 1
}, {
  id: 159,
  studentName: 'Ali Al Mazrouei',
  program: 'Bachelor of Business Administration',
  programId: 9,
  status: 'Rejected',
  submissionDate: '2023-06-06',
  eligibility: 'Ineligible',
  universityId: 1
}, {
  id: 160,
  studentName: 'Hessa Al Mansouri',
  program: 'Master of Public Administration',
  programId: 3,
  status: 'Pending',
  submissionDate: '2023-06-05',
  eligibility: 'Eligible',
  universityId: 1
}, {
  id: 161,
  studentName: 'Abdulrahman Al Awar',
  program: 'PhD in Business Analytics',
  programId: 10,
  status: 'Under Review',
  submissionDate: '2023-06-04',
  eligibility: 'Needs Review',
  universityId: 1
}, {
  id: 162,
  studentName: 'Moza Al Nahyan',
  program: 'Bachelor of Finance',
  programId: 11,
  status: 'Accepted',
  submissionDate: '2023-06-03',
  eligibility: 'Eligible',
  universityId: 1
}, {
  id: 163,
  studentName: 'Rashid Al Nuaimi',
  program: 'Master of Marketing',
  programId: 12,
  status: 'Pending',
  submissionDate: '2023-06-02',
  eligibility: 'Eligible',
  universityId: 1
}, {
  id: 164,
  studentName: 'Sheikha Al Mualla',
  program: 'Bachelor of Accounting',
  programId: 13,
  status: 'Rejected',
  submissionDate: '2023-06-01',
  eligibility: 'Ineligible',
  universityId: 1
}, {
  id: 165,
  studentName: 'Majid Al Futtaim',
  program: 'Master of Finance',
  programId: 14,
  status: 'Accepted',
  submissionDate: '2023-05-31',
  eligibility: 'Eligible',
  universityId: 1
}, {
  id: 166,
  studentName: 'Amna Al Haddad',
  program: 'PhD in Economics',
  programId: 15,
  status: 'Under Review',
  submissionDate: '2023-05-30',
  eligibility: 'Needs Review',
  universityId: 1
}, {
  id: 167,
  studentName: 'Tariq Al Gurg',
  program: 'Bachelor of International Business',
  programId: 16,
  status: 'Pending',
  submissionDate: '2023-05-29',
  eligibility: 'Eligible',
  universityId: 1
}, {
  id: 168,
  studentName: 'Lubna Al Qasimi',
  program: 'Executive MBA',
  programId: 17,
  status: 'Accepted',
  submissionDate: '2023-05-28',
  eligibility: 'Eligible',
  universityId: 1
}, {
  id: 169,
  studentName: 'Sultan Al Jaber',
  program: 'Master of Business Administration',
  programId: 1,
  status: 'Pending',
  submissionDate: '2023-05-27',
  eligibility: 'Eligible',
  universityId: 1
}, {
  id: 170,
  studentName: 'Maitha Al Shamsi',
  program: 'Bachelor of Business Administration',
  programId: 9,
  status: 'Under Review',
  submissionDate: '2023-05-26',
  eligibility: 'Needs Review',
  universityId: 1
}, {
  id: 171,
  studentName: 'Obaid Al Tayer',
  program: 'Master of Public Administration',
  programId: 3,
  status: 'Accepted',
  submissionDate: '2023-05-25',
  eligibility: 'Eligible',
  universityId: 1
}, {
  id: 172,
  studentName: 'Jawaher Al Qasimi',
  program: 'PhD in Business Analytics',
  programId: 10,
  status: 'Rejected',
  submissionDate: '2023-05-24',
  eligibility: 'Ineligible',
  universityId: 1
}, {
  id: 173,
  studentName: 'Yousef Al Otaiba',
  program: 'Bachelor of Finance',
  programId: 11,
  status: 'Pending',
  submissionDate: '2023-05-23',
  eligibility: 'Eligible',
  universityId: 1
}, {
  id: 174,
  studentName: 'Shamma Al Mazrui',
  program: 'Master of Marketing',
  programId: 12,
  status: 'Accepted',
  submissionDate: '2023-05-22',
  eligibility: 'Eligible',
  universityId: 1
}, {
  id: 175,
  studentName: 'Thani Al Zeyoudi',
  program: 'Bachelor of Accounting',
  programId: 13,
  status: 'Under Review',
  submissionDate: '2023-05-21',
  eligibility: 'Needs Review',
  universityId: 1
}, {
  id: 176,
  studentName: 'Noora Al Kaabi',
  program: 'Master of Finance',
  programId: 14,
  status: 'Pending',
  submissionDate: '2023-05-20',
  eligibility: 'Eligible',
  universityId: 1
}, {
  id: 177,
  studentName: 'Abdulla Al Ghurair',
  program: 'PhD in Economics',
  programId: 15,
  status: 'Accepted',
  submissionDate: '2023-05-19',
  eligibility: 'Eligible',
  universityId: 1
}, {
  id: 178,
  studentName: 'Manal Al Sharif',
  program: 'Bachelor of International Business',
  programId: 16,
  status: 'Rejected',
  submissionDate: '2023-05-18',
  eligibility: 'Ineligible',
  universityId: 1
}, {
  id: 179,
  studentName: 'Hussain Al Nowais',
  program: 'Executive MBA',
  programId: 17,
  status: 'Pending',
  submissionDate: '2023-05-17',
  eligibility: 'Eligible',
  universityId: 1
}, {
  id: 180,
  studentName: 'Razan Al Mubarak',
  program: 'Master of Business Administration',
  programId: 1,
  status: 'Under Review',
  submissionDate: '2023-05-16',
  eligibility: 'Needs Review',
  universityId: 1
}, {
  id: 181,
  studentName: 'Abdulla Al Humaidi',
  program: 'Bachelor of Business Administration',
  programId: 9,
  status: 'Accepted',
  submissionDate: '2023-05-15',
  eligibility: 'Eligible',
  universityId: 1
}, {
  id: 182,
  studentName: 'Salama Al Ketbi',
  program: 'Master of Public Administration',
  programId: 3,
  status: 'Pending',
  submissionDate: '2023-05-14',
  eligibility: 'Eligible',
  universityId: 1
}, {
  id: 183,
  studentName: 'Saqr Al Qasimi',
  program: 'PhD in Business Analytics',
  programId: 10,
  status: 'Under Review',
  submissionDate: '2023-05-13',
  eligibility: 'Needs Review',
  universityId: 1
}, {
  id: 184,
  studentName: 'Badria Al Mulla',
  program: 'Bachelor of Finance',
  programId: 11,
  status: 'Accepted',
  submissionDate: '2023-05-12',
  eligibility: 'Eligible',
  universityId: 1
}, {
  id: 185,
  studentName: 'Faisal Al Bannai',
  program: 'Master of Marketing',
  programId: 12,
  status: 'Rejected',
  submissionDate: '2023-05-11',
  eligibility: 'Ineligible',
  universityId: 1
}, {
  id: 186,
  studentName: 'Hala Al Gergawi',
  program: 'Bachelor of Accounting',
  programId: 13,
  status: 'Pending',
  submissionDate: '2023-05-10',
  eligibility: 'Eligible',
  universityId: 1
}, {
  id: 187,
  studentName: 'Khalfan Al Mazrouei',
  program: 'Master of Finance',
  programId: 14,
  status: 'Accepted',
  submissionDate: '2023-05-09',
  eligibility: 'Eligible',
  universityId: 1
}, {
  id: 188,
  studentName: 'Maryam Al Hammadi',
  program: 'PhD in Economics',
  programId: 15,
  status: 'Under Review',
  submissionDate: '2023-05-08',
  eligibility: 'Needs Review',
  universityId: 1
}, {
  id: 189,
  studentName: 'Fahad Al Gergawi',
  program: 'Bachelor of International Business',
  programId: 16,
  status: 'Pending',
  submissionDate: '2023-05-07',
  eligibility: 'Eligible',
  universityId: 1
}, {
  id: 190,
  studentName: 'Nayla Al Khaja',
  program: 'Executive MBA',
  programId: 17,
  status: 'Accepted',
  submissionDate: '2023-05-06',
  eligibility: 'Eligible',
  universityId: 1
}, {
  id: 191,
  studentName: 'Essa Al Maidoor',
  program: 'Master of Business Administration',
  programId: 1,
  status: 'Pending',
  submissionDate: '2023-05-05',
  eligibility: 'Eligible',
  universityId: 1
}, {
  id: 192,
  studentName: 'Najla Al Midfa',
  program: 'Bachelor of Business Administration',
  programId: 9,
  status: 'Rejected',
  submissionDate: '2023-05-04',
  eligibility: 'Ineligible',
  universityId: 1
}, {
  id: 193,
  studentName: 'Humaid Al Qutami',
  program: 'Master of Public Administration',
  programId: 3,
  status: 'Under Review',
  submissionDate: '2023-05-03',
  eligibility: 'Needs Review',
  universityId: 1
}, {
  id: 194,
  studentName: 'Afra Al Basti',
  program: 'PhD in Business Analytics',
  programId: 10,
  status: 'Accepted',
  submissionDate: '2023-05-02',
  eligibility: 'Eligible',
  universityId: 1
}, {
  id: 195,
  studentName: 'Saif Al Ghurair',
  program: 'Bachelor of Finance',
  programId: 11,
  status: 'Pending',
  submissionDate: '2023-05-01',
  eligibility: 'Eligible',
  universityId: 1
},
// Emirates Institute of Technology (universityId: 2) applications - 50 entries
{
  id: 106,
  studentName: 'Ali Al Hashimi',
  program: 'Bachelor of Computer Science',
  programId: 2,
  status: 'Accepted',
  submissionDate: '2023-06-14',
  eligibility: 'Eligible',
  universityId: 2
}, {
  id: 107,
  studentName: 'Mariam Al Suwaidi',
  program: 'PhD in Data Science',
  programId: 4,
  status: 'Under Review',
  submissionDate: '2023-06-11',
  eligibility: 'Needs Review',
  universityId: 2
}, {
  id: 201,
  studentName: 'Rashid Al Dhaheri',
  program: 'Master of Computer Science',
  programId: 18,
  status: 'Pending',
  submissionDate: '2023-06-15',
  eligibility: 'Eligible',
  universityId: 2
}, {
  id: 202,
  studentName: 'Layla Al Shamsi',
  program: 'Bachelor of Cybersecurity',
  programId: 19,
  status: 'Accepted',
  submissionDate: '2023-06-14',
  eligibility: 'Eligible',
  universityId: 2
}, {
  id: 203,
  studentName: 'Hassan Al Zaabi',
  program: 'Master of Artificial Intelligence',
  programId: 20,
  status: 'Under Review',
  submissionDate: '2023-06-13',
  eligibility: 'Needs Review',
  universityId: 2
}, {
  id: 204,
  studentName: 'Noor Al Falasi',
  program: 'Bachelor of Software Engineering',
  programId: 21,
  status: 'Pending',
  submissionDate: '2023-06-12',
  eligibility: 'Eligible',
  universityId: 2
}, {
  id: 205,
  studentName: 'Khalid Al Muhairi',
  program: 'Master of Information Systems',
  programId: 22,
  status: 'Rejected',
  submissionDate: '2023-06-11',
  eligibility: 'Ineligible',
  universityId: 2
}, {
  id: 206,
  studentName: 'Amal Al Qubaisi',
  program: 'PhD in Cybersecurity',
  programId: 23,
  status: 'Accepted',
  submissionDate: '2023-06-10',
  eligibility: 'Eligible',
  universityId: 2
}, {
  id: 207,
  studentName: 'Saif Al Mansouri',
  program: 'Bachelor of Network Engineering',
  programId: 24,
  status: 'Under Review',
  submissionDate: '2023-06-09',
  eligibility: 'Needs Review',
  universityId: 2
}, {
  id: 208,
  studentName: 'Fatima Al Jaber',
  program: 'Master of Data Analytics',
  programId: 25,
  status: 'Pending',
  submissionDate: '2023-06-08',
  eligibility: 'Eligible',
  universityId: 2
}, {
  id: 209,
  studentName: 'Ahmed Al Zarooni',
  program: 'Bachelor of Information Technology',
  programId: 26,
  status: 'Accepted',
  submissionDate: '2023-06-07',
  eligibility: 'Eligible',
  universityId: 2
}, {
  id: 210,
  studentName: 'Sheikha Al Maktoum',
  program: 'Bachelor of Computer Science',
  programId: 2,
  status: 'Pending',
  submissionDate: '2023-06-06',
  eligibility: 'Eligible',
  universityId: 2
}, {
  id: 211,
  studentName: 'Hamdan Al Nahyan',
  program: 'PhD in Data Science',
  programId: 4,
  status: 'Under Review',
  submissionDate: '2023-06-05',
  eligibility: 'Needs Review',
  universityId: 2
}, {
  id: 212,
  studentName: 'Mona Al Marri',
  program: 'Master of Computer Science',
  programId: 18,
  status: 'Accepted',
  submissionDate: '2023-06-04',
  eligibility: 'Eligible',
  universityId: 2
}, {
  id: 213,
  studentName: 'Abdulaziz Al Ghurair',
  program: 'Bachelor of Cybersecurity',
  programId: 19,
  status: 'Rejected',
  submissionDate: '2023-06-03',
  eligibility: 'Ineligible',
  universityId: 2
}, {
  id: 214,
  studentName: 'Hind Al Rostamani',
  program: 'Master of Artificial Intelligence',
  programId: 20,
  status: 'Pending',
  submissionDate: '2023-06-02',
  eligibility: 'Eligible',
  universityId: 2
}, {
  id: 215,
  studentName: 'Mohammed Al Abbar',
  program: 'Bachelor of Software Engineering',
  programId: 21,
  status: 'Accepted',
  submissionDate: '2023-06-01',
  eligibility: 'Eligible',
  universityId: 2
}, {
  id: 216,
  studentName: 'Amina Al Rustamani',
  program: 'Master of Information Systems',
  programId: 22,
  status: 'Under Review',
  submissionDate: '2023-05-31',
  eligibility: 'Needs Review',
  universityId: 2
}, {
  id: 217,
  studentName: 'Khalifa Al Zaffin',
  program: 'PhD in Cybersecurity',
  programId: 23,
  status: 'Pending',
  submissionDate: '2023-05-30',
  eligibility: 'Eligible',
  universityId: 2
}, {
  id: 218,
  studentName: 'Salma Al Darmaki',
  program: 'Bachelor of Network Engineering',
  programId: 24,
  status: 'Accepted',
  submissionDate: '2023-05-29',
  eligibility: 'Eligible',
  universityId: 2
}, {
  id: 219,
  studentName: 'Majed Al Sorour',
  program: 'Master of Data Analytics',
  programId: 25,
  status: 'Rejected',
  submissionDate: '2023-05-28',
  eligibility: 'Ineligible',
  universityId: 2
}, {
  id: 220,
  studentName: 'Rasha Al Qassim',
  program: 'Bachelor of Information Technology',
  programId: 26,
  status: 'Pending',
  submissionDate: '2023-05-27',
  eligibility: 'Eligible',
  universityId: 2
}, {
  id: 221,
  studentName: 'Saeed Al Muntafiq',
  program: 'Bachelor of Computer Science',
  programId: 2,
  status: 'Under Review',
  submissionDate: '2023-05-26',
  eligibility: 'Needs Review',
  universityId: 2
}, {
  id: 222,
  studentName: 'Alia Al Mazrouei',
  program: 'PhD in Data Science',
  programId: 4,
  status: 'Accepted',
  submissionDate: '2023-05-25',
  eligibility: 'Eligible',
  universityId: 2
}, {
  id: 223,
  studentName: 'Fadi Al Said',
  program: 'Master of Computer Science',
  programId: 18,
  status: 'Pending',
  submissionDate: '2023-05-24',
  eligibility: 'Eligible',
  universityId: 2
}, {
  id: 224,
  studentName: 'Maha Al Ghunaim',
  program: 'Bachelor of Cybersecurity',
  programId: 19,
  status: 'Accepted',
  submissionDate: '2023-05-23',
  eligibility: 'Eligible',
  universityId: 2
}, {
  id: 225,
  studentName: 'Waleed Al Mokarrab',
  program: 'Master of Artificial Intelligence',
  programId: 20,
  status: 'Under Review',
  submissionDate: '2023-05-22',
  eligibility: 'Needs Review',
  universityId: 2
}, {
  id: 226,
  studentName: 'Muna Al Gurg',
  program: 'Bachelor of Software Engineering',
  programId: 21,
  status: 'Rejected',
  submissionDate: '2023-05-21',
  eligibility: 'Ineligible',
  universityId: 2
}, {
  id: 227,
  studentName: 'Jassim Al Seddiqi',
  program: 'Master of Information Systems',
  programId: 22,
  status: 'Pending',
  submissionDate: '2023-05-20',
  eligibility: 'Eligible',
  universityId: 2
}, {
  id: 228,
  studentName: 'Ameera Al Taweel',
  program: 'PhD in Cybersecurity',
  programId: 23,
  status: 'Accepted',
  submissionDate: '2023-05-19',
  eligibility: 'Eligible',
  universityId: 2
}, {
  id: 229,
  studentName: 'Sami Al Qamzi',
  program: 'Bachelor of Network Engineering',
  programId: 24,
  status: 'Under Review',
  submissionDate: '2023-05-18',
  eligibility: 'Needs Review',
  universityId: 2
}, {
  id: 230,
  studentName: 'Huda Al Matroushi',
  program: 'Master of Data Analytics',
  programId: 25,
  status: 'Pending',
  submissionDate: '2023-05-17',
  eligibility: 'Eligible',
  universityId: 2
}, {
  id: 231,
  studentName: 'Younis Al Khoori',
  program: 'Bachelor of Information Technology',
  programId: 26,
  status: 'Accepted',
  submissionDate: '2023-05-16',
  eligibility: 'Eligible',
  universityId: 2
}, {
  id: 232,
  studentName: 'Zainab Al Eqabi',
  program: 'Bachelor of Computer Science',
  programId: 2,
  status: 'Rejected',
  submissionDate: '2023-05-15',
  eligibility: 'Ineligible',
  universityId: 2
}, {
  id: 233,
  studentName: 'Jamal Al Hai',
  program: 'PhD in Data Science',
  programId: 4,
  status: 'Pending',
  submissionDate: '2023-05-14',
  eligibility: 'Eligible',
  universityId: 2
}, {
  id: 234,
  studentName: 'Dalal Al Mheiri',
  program: 'Master of Computer Science',
  programId: 18,
  status: 'Under Review',
  submissionDate: '2023-05-13',
  eligibility: 'Needs Review',
  universityId: 2
}, {
  id: 235,
  studentName: 'Essa Al Ghurair',
  program: 'Bachelor of Cybersecurity',
  programId: 19,
  status: 'Accepted',
  submissionDate: '2023-05-12',
  eligibility: 'Eligible',
  universityId: 2
}, {
  id: 236,
  studentName: 'Shaikha Al Maskari',
  program: 'Master of Artificial Intelligence',
  programId: 20,
  status: 'Pending',
  submissionDate: '2023-05-11',
  eligibility: 'Eligible',
  universityId: 2
}, {
  id: 237,
  studentName: 'Marwan Al Sawaleh',
  program: 'Bachelor of Software Engineering',
  programId: 21,
  status: 'Accepted',
  submissionDate: '2023-05-10',
  eligibility: 'Eligible',
  universityId: 2
}, {
  id: 238,
  studentName: 'Farida Al Awadhi',
  program: 'Master of Information Systems',
  programId: 22,
  status: 'Under Review',
  submissionDate: '2023-05-09',
  eligibility: 'Needs Review',
  universityId: 2
}, {
  id: 239,
  studentName: 'Khaldoon Al Mubarak',
  program: 'PhD in Cybersecurity',
  programId: 23,
  status: 'Rejected',
  submissionDate: '2023-05-08',
  eligibility: 'Ineligible',
  universityId: 2
}, {
  id: 240,
  studentName: 'Alanoud Al Hashmi',
  program: 'Bachelor of Network Engineering',
  programId: 24,
  status: 'Pending',
  submissionDate: '2023-05-07',
  eligibility: 'Eligible',
  universityId: 2
}, {
  id: 241,
  studentName: 'Nasser Al Neyadi',
  program: 'Master of Data Analytics',
  programId: 25,
  status: 'Accepted',
  submissionDate: '2023-05-06',
  eligibility: 'Eligible',
  universityId: 2
}, {
  id: 242,
  studentName: 'Maha Al Shehi',
  program: 'Bachelor of Information Technology',
  programId: 26,
  status: 'Under Review',
  submissionDate: '2023-05-05',
  eligibility: 'Needs Review',
  universityId: 2
}, {
  id: 243,
  studentName: 'Abdulrahman Al Saleh',
  program: 'Bachelor of Computer Science',
  programId: 2,
  status: 'Pending',
  submissionDate: '2023-05-04',
  eligibility: 'Eligible',
  universityId: 2
}, {
  id: 244,
  studentName: 'Maitha Al Khayat',
  program: 'PhD in Data Science',
  programId: 4,
  status: 'Accepted',
  submissionDate: '2023-05-03',
  eligibility: 'Eligible',
  universityId: 2
}, {
  id: 245,
  studentName: 'Khalid Al Kamda',
  program: 'Master of Computer Science',
  programId: 18,
  status: 'Rejected',
  submissionDate: '2023-05-02',
  eligibility: 'Ineligible',
  universityId: 2
}, {
  id: 246,
  studentName: 'Roudha Al Marri',
  program: 'Bachelor of Cybersecurity',
  programId: 19,
  status: 'Pending',
  submissionDate: '2023-05-01',
  eligibility: 'Eligible',
  universityId: 2
}, {
  id: 247,
  studentName: 'Adel Al Redha',
  program: 'Master of Artificial Intelligence',
  programId: 20,
  status: 'Under Review',
  submissionDate: '2023-04-30',
  eligibility: 'Needs Review',
  universityId: 2
}, {
  id: 248,
  studentName: 'Ayesha Al Janahi',
  program: 'Bachelor of Software Engineering',
  programId: 21,
  status: 'Accepted',
  submissionDate: '2023-04-29',
  eligibility: 'Eligible',
  universityId: 2
}, {
  id: 249,
  studentName: 'Salem Al Moosa',
  program: 'Master of Information Systems',
  programId: 22,
  status: 'Pending',
  submissionDate: '2023-04-28',
  eligibility: 'Eligible',
  universityId: 2
}, {
  id: 250,
  studentName: 'Rawdha Al Ketbi',
  program: 'PhD in Cybersecurity',
  programId: 23,
  status: 'Accepted',
  submissionDate: '2023-04-27',
  eligibility: 'Eligible',
  universityId: 2
},
// Dubai Medical College (universityId: 4) applications - 50 entries
{
  id: 108,
  studentName: 'Khalid Al Qasimi',
  program: 'Bachelor of Nursing',
  programId: 5,
  status: 'Pending',
  submissionDate: '2023-06-04',
  eligibility: 'Eligible',
  universityId: 4
}, {
  id: 301,
  studentName: 'Asma Al Janahi',
  program: 'Doctor of Medicine',
  programId: 37,
  status: 'Under Review',
  submissionDate: '2023-06-15',
  eligibility: 'Needs Review',
  universityId: 4
}, {
  id: 302,
  studentName: 'Fahad Al Blooshi',
  program: 'Bachelor of Pharmacy',
  programId: 38,
  status: 'Accepted',
  submissionDate: '2023-06-14',
  eligibility: 'Eligible',
  universityId: 4
}, {
  id: 303,
  studentName: 'Hessa Al Falasi',
  program: 'Master of Public Health',
  programId: 39,
  status: 'Pending',
  submissionDate: '2023-06-13',
  eligibility: 'Eligible',
  universityId: 4
}, {
  id: 304,
  studentName: 'Tariq Al Qassimi',
  program: 'Bachelor of Medical Laboratory Sciences',
  programId: 40,
  status: 'Rejected',
  submissionDate: '2023-06-12',
  eligibility: 'Ineligible',
  universityId: 4
}, {
  id: 305,
  studentName: 'Mona Al Hashemi',
  program: 'Master of Nursing',
  programId: 41,
  status: 'Accepted',
  submissionDate: '2023-06-11',
  eligibility: 'Eligible',
  universityId: 4
}, {
  id: 306,
  studentName: 'Saif Al Suwaidi',
  program: 'PhD in Pharmaceutical Sciences',
  programId: 42,
  status: 'Under Review',
  submissionDate: '2023-06-10',
  eligibility: 'Needs Review',
  universityId: 4
}, {
  id: 307,
  studentName: 'Nouf Al Kaabi',
  program: 'Bachelor of Physiotherapy',
  programId: 43,
  status: 'Pending',
  submissionDate: '2023-06-09',
  eligibility: 'Eligible',
  universityId: 4
}, {
  id: 308,
  studentName: 'Omar Al Olama',
  program: 'Master of Clinical Psychology',
  programId: 44,
  status: 'Accepted',
  submissionDate: '2023-06-08',
  eligibility: 'Eligible',
  universityId: 4
}, {
  id: 309,
  studentName: 'Mariam Al Mheiri',
  program: 'Bachelor of Dental Surgery',
  programId: 45,
  status: 'Under Review',
  submissionDate: '2023-06-07',
  eligibility: 'Needs Review',
  universityId: 4
}, {
  id: 310,
  studentName: 'Abdullah Al Nuaimi',
  program: 'Bachelor of Nursing',
  programId: 5,
  status: 'Rejected',
  submissionDate: '2023-06-06',
  eligibility: 'Ineligible',
  universityId: 4
}, {
  id: 311,
  studentName: 'Latifa Al Shamsi',
  program: 'Doctor of Medicine',
  programId: 37,
  status: 'Pending',
  submissionDate: '2023-06-05',
  eligibility: 'Eligible',
  universityId: 4
}, {
  id: 312,
  studentName: 'Mansoor Al Awar',
  program: 'Bachelor of Pharmacy',
  programId: 38,
  status: 'Accepted',
  submissionDate: '2023-06-04',
  eligibility: 'Eligible',
  universityId: 4
}, {
  id: 313,
  studentName: 'Aisha Al Dhaheri',
  program: 'Master of Public Health',
  programId: 39,
  status: 'Under Review',
  submissionDate: '2023-06-03',
  eligibility: 'Needs Review',
  universityId: 4
}, {
  id: 314,
  studentName: 'Hamad Al Sharqi',
  program: 'Bachelor of Medical Laboratory Sciences',
  programId: 40,
  status: 'Pending',
  submissionDate: '2023-06-02',
  eligibility: 'Eligible',
  universityId: 4
}, {
  id: 315,
  studentName: 'Shamma Al Mualla',
  program: 'Master of Nursing',
  programId: 41,
  status: 'Accepted',
  submissionDate: '2023-06-01',
  eligibility: 'Eligible',
  universityId: 4
}, {
  id: 316,
  studentName: 'Khalifa Al Romaithi',
  program: 'PhD in Pharmaceutical Sciences',
  programId: 42,
  status: 'Rejected',
  submissionDate: '2023-05-31',
  eligibility: 'Ineligible',
  universityId: 4
}, {
  id: 317,
  studentName: 'Mahra Al Maktoum',
  program: 'Bachelor of Physiotherapy',
  programId: 43,
  status: 'Pending',
  submissionDate: '2023-05-30',
  eligibility: 'Eligible',
  universityId: 4
}, {
  id: 318,
  studentName: 'Adnan Al Awadhi',
  program: 'Master of Clinical Psychology',
  programId: 44,
  status: 'Under Review',
  submissionDate: '2023-05-29',
  eligibility: 'Needs Review',
  universityId: 4
}, {
  id: 319,
  studentName: 'Hanan Al Zarooni',
  program: 'Bachelor of Dental Surgery',
  programId: 45,
  status: 'Accepted',
  submissionDate: '2023-05-28',
  eligibility: 'Eligible',
  universityId: 4
}, {
  id: 320,
  studentName: 'Rashed Al Maktoum',
  program: 'Bachelor of Nursing',
  programId: 5,
  status: 'Pending',
  submissionDate: '2023-05-27',
  eligibility: 'Eligible',
  universityId: 4
}, {
  id: 321,
  studentName: 'Azza Al Qubaisi',
  program: 'Doctor of Medicine',
  programId: 37,
  status: 'Accepted',
  submissionDate: '2023-05-26',
  eligibility: 'Eligible',
  universityId: 4
}, {
  id: 322,
  studentName: 'Majid Al Futtaim',
  program: 'Bachelor of Pharmacy',
  programId: 38,
  status: 'Under Review',
  submissionDate: '2023-05-25',
  eligibility: 'Needs Review',
  universityId: 4
}, {
  id: 323,
  studentName: 'Moza Al Maktoum',
  program: 'Master of Public Health',
  programId: 39,
  status: 'Rejected',
  submissionDate: '2023-05-24',
  eligibility: 'Ineligible',
  universityId: 4
}, {
  id: 324,
  studentName: 'Saif Al Ghafli',
  program: 'Bachelor of Medical Laboratory Sciences',
  programId: 40,
  status: 'Pending',
  submissionDate: '2023-05-23',
  eligibility: 'Eligible',
  universityId: 4
}, {
  id: 325,
  studentName: 'Alya Al Mazrouei',
  program: 'Master of Nursing',
  programId: 41,
  status: 'Accepted',
  submissionDate: '2023-05-22',
  eligibility: 'Eligible',
  universityId: 4
}, {
  id: 326,
  studentName: 'Nawaf Al Naboodah',
  program: 'PhD in Pharmaceutical Sciences',
  programId: 42,
  status: 'Under Review',
  submissionDate: '2023-05-21',
  eligibility: 'Needs Review',
  universityId: 4
}, {
  id: 327,
  studentName: 'Amani Al Jasmi',
  program: 'Bachelor of Physiotherapy',
  programId: 43,
  status: 'Pending',
  submissionDate: '2023-05-20',
  eligibility: 'Eligible',
  universityId: 4
}, {
  id: 328,
  studentName: 'Faisal Al Ketbi',
  program: 'Master of Clinical Psychology',
  programId: 44,
  status: 'Rejected',
  submissionDate: '2023-05-19',
  eligibility: 'Ineligible',
  universityId: 4
}, {
  id: 329,
  studentName: 'Sara Al Madani',
  program: 'Bachelor of Dental Surgery',
  programId: 45,
  status: 'Accepted',
  submissionDate: '2023-05-18',
  eligibility: 'Eligible',
  universityId: 4
}, {
  id: 330,
  studentName: 'Abdulrahman Al Owais',
  program: 'Bachelor of Nursing',
  programId: 5,
  status: 'Under Review',
  submissionDate: '2023-05-17',
  eligibility: 'Needs Review',
  universityId: 4
}, {
  id: 331,
  studentName: 'Meera Al Suwaidi',
  program: 'Doctor of Medicine',
  programId: 37,
  status: 'Pending',
  submissionDate: '2023-05-16',
  eligibility: 'Eligible',
  universityId: 4
}, {
  id: 332,
  studentName: 'Hamdan Al Maktoum',
  program: 'Bachelor of Pharmacy',
  programId: 38,
  status: 'Accepted',
  submissionDate: '2023-05-15',
  eligibility: 'Eligible',
  universityId: 4
}, {
  id: 333,
  studentName: 'Reem Al Hashimy',
  program: 'Master of Public Health',
  programId: 39,
  status: 'Under Review',
  submissionDate: '2023-05-14',
  eligibility: 'Needs Review',
  universityId: 4
}, {
  id: 334,
  studentName: 'Ahmed Al Matrooshi',
  program: 'Bachelor of Medical Laboratory Sciences',
  programId: 40,
  status: 'Rejected',
  submissionDate: '2023-05-13',
  eligibility: 'Ineligible',
  universityId: 4
}, {
  id: 335,
  studentName: 'Khawla Al Mehairi',
  program: 'Master of Nursing',
  programId: 41,
  status: 'Pending',
  submissionDate: '2023-05-12',
  eligibility: 'Eligible',
  universityId: 4
}, {
  id: 336,
  studentName: 'Sultan Al Mansouri',
  program: 'PhD in Pharmaceutical Sciences',
  programId: 42,
  status: 'Accepted',
  submissionDate: '2023-05-11',
  eligibility: 'Eligible',
  universityId: 4
}, {
  id: 337,
  studentName: 'Jamila Al Fandi',
  program: 'Bachelor of Physiotherapy',
  programId: 43,
  status: 'Under Review',
  submissionDate: '2023-05-10',
  eligibility: 'Needs Review',
  universityId: 4
}, {
  id: 338,
  studentName: 'Zayed Al Falasi',
  program: 'Master of Clinical Psychology',
  programId: 44,
  status: 'Pending',
  submissionDate: '2023-05-09',
  eligibility: 'Eligible',
  universityId: 4
}, {
  id: 339,
  studentName: 'Lamia Al Muhairi',
  program: 'Bachelor of Dental Surgery',
  programId: 45,
  status: 'Accepted',
  submissionDate: '2023-05-08',
  eligibility: 'Eligible',
  universityId: 4
}, {
  id: 340,
  studentName: 'Mubarak Al Nahyan',
  program: 'Bachelor of Nursing',
  programId: 5,
  status: 'Rejected',
  submissionDate: '2023-05-07',
  eligibility: 'Ineligible',
  universityId: 4
}, {
  id: 341,
  studentName: 'Ahlam Al Shamsi',
  program: 'Doctor of Medicine',
  programId: 37,
  status: 'Pending',
  submissionDate: '2023-05-06',
  eligibility: 'Eligible',
  universityId: 4
}, {
  id: 342,
  studentName: 'Humaid Al Qatami',
  program: 'Bachelor of Pharmacy',
  programId: 38,
  status: 'Under Review',
  submissionDate: '2023-05-05',
  eligibility: 'Needs Review',
  universityId: 4
}, {
  id: 343,
  studentName: 'Maryam Al Roumi',
  program: 'Master of Public Health',
  programId: 39,
  status: 'Accepted',
  submissionDate: '2023-05-04',
  eligibility: 'Eligible',
  universityId: 4
}, {
  id: 344,
  studentName: 'Obaid Al Tayer',
  program: 'Bachelor of Medical Laboratory Sciences',
  programId: 40,
  status: 'Pending',
  submissionDate: '2023-05-03',
  eligibility: 'Eligible',
  universityId: 4
}, {
  id: 345,
  studentName: 'Lubna Al Qasimi',
  program: 'Master of Nursing',
  programId: 41,
  status: 'Accepted',
  submissionDate: '2023-05-02',
  eligibility: 'Eligible',
  universityId: 4
}, {
  id: 346,
  studentName: 'Khalid Al Falasi',
  program: 'PhD in Pharmaceutical Sciences',
  programId: 42,
  status: 'Rejected',
  submissionDate: '2023-05-01',
  eligibility: 'Ineligible',
  universityId: 4
}, {
  id: 347,
  studentName: 'Laila Al Muhairi',
  program: 'Bachelor of Physiotherapy',
  programId: 43,
  status: 'Pending',
  submissionDate: '2023-04-30',
  eligibility: 'Eligible',
  universityId: 4
}, {
  id: 348,
  studentName: 'Marwan Al Sawaleh',
  program: 'Master of Clinical Psychology',
  programId: 44,
  status: 'Under Review',
  submissionDate: '2023-04-29',
  eligibility: 'Needs Review',
  universityId: 4
}, {
  id: 349,
  studentName: 'Maitha Al Marar',
  program: 'Bachelor of Dental Surgery',
  programId: 45,
  status: 'Accepted',
  submissionDate: '2023-04-28',
  eligibility: 'Eligible',
  universityId: 4
}, {
  id: 350,
  studentName: 'Ahmed Al Raisi',
  program: 'Bachelor of Nursing',
  programId: 5,
  status: 'Pending',
  submissionDate: '2023-04-27',
  eligibility: 'Eligible',
  universityId: 4
},
// Abu Dhabi School of Management (universityId: 5) applications - 50 entries
{
  id: 401,
  studentName: 'Fatima Al Jaber',
  program: 'Master of Business Administration',
  programId: 46,
  status: 'Pending',
  submissionDate: '2023-06-15',
  eligibility: 'Eligible',
  universityId: 5
}, {
  id: 402,
  studentName: 'Hassan Al Suwaidi',
  program: 'Bachelor of Business Management',
  programId: 47,
  status: 'Under Review',
  submissionDate: '2023-06-14',
  eligibility: 'Needs Review',
  universityId: 5
}, {
  id: 403,
  studentName: 'Maha Al Ghunaim',
  program: 'Master of Finance',
  programId: 48,
  status: 'Accepted',
  submissionDate: '2023-06-13',
  eligibility: 'Eligible',
  universityId: 5
}, {
  id: 404,
  studentName: 'Khaled Al Kamda',
  program: 'Bachelor of Marketing',
  programId: 49,
  status: 'Rejected',
  submissionDate: '2023-06-12',
  eligibility: 'Ineligible',
  universityId: 5
}, {
  id: 405,
  studentName: 'Amal Al Qubaisi',
  program: 'Master of Human Resources Management',
  programId: 50,
  status: 'Pending',
  submissionDate: '2023-06-11',
  eligibility: 'Eligible',
  universityId: 5
}, {
  id: 406,
  studentName: 'Fahad Al Hassawi',
  program: 'Bachelor of Accounting',
  programId: 51,
  status: 'Accepted',
  submissionDate: '2023-06-10',
  eligibility: 'Eligible',
  universityId: 5
}, {
  id: 407,
  studentName: 'Nada Al Hashimi',
  program: 'Executive MBA',
  programId: 52,
  status: 'Under Review',
  submissionDate: '2023-06-09',
  eligibility: 'Needs Review',
  universityId: 5
}, {
  id: 408,
  studentName: 'Saeed Al Muntafiq',
  program: 'Bachelor of International Business',
  programId: 53,
  status: 'Pending',
  submissionDate: '2023-06-08',
  eligibility: 'Eligible',
  universityId: 5
}, {
  id: 409,
  studentName: 'Hind Al Rostamani',
  program: 'Master of Project Management',
  programId: 54,
  status: 'Accepted',
  submissionDate: '2023-06-07',
  eligibility: 'Eligible',
  universityId: 5
}, {
  id: 410,
  studentName: 'Mohammed Al Shaibani',
  program: 'PhD in Business Management',
  programId: 55,
  status: 'Rejected',
  submissionDate: '2023-06-06',
  eligibility: 'Ineligible',
  universityId: 5
}, {
  id: 411,
  studentName: 'Rania Al Mashat',
  program: 'Master of Business Administration',
  programId: 46,
  status: 'Pending',
  submissionDate: '2023-06-05',
  eligibility: 'Eligible',
  universityId: 5
}, {
  id: 412,
  studentName: 'Anwar Al Amin',
  program: 'Bachelor of Business Management',
  programId: 47,
  status: 'Under Review',
  submissionDate: '2023-06-04',
  eligibility: 'Needs Review',
  universityId: 5
}, {
  id: 413,
  studentName: 'Salma Al Hashemi',
  program: 'Master of Finance',
  programId: 48,
  status: 'Accepted',
  submissionDate: '2023-06-03',
  eligibility: 'Eligible',
  universityId: 5
}, {
  id: 414,
  studentName: 'Fadi Al Gergawi',
  program: 'Bachelor of Marketing',
  programId: 49,
  status: 'Pending',
  submissionDate: '2023-06-02',
  eligibility: 'Eligible',
  universityId: 5
}, {
  id: 415,
  studentName: 'Mona Al Marri',
  program: 'Master of Human Resources Management',
  programId: 50,
  status: 'Accepted',
  submissionDate: '2023-06-01',
  eligibility: 'Eligible',
  universityId: 5
}, {
  id: 416,
  studentName: 'Hussain Al Qemzi',
  program: 'Bachelor of Accounting',
  programId: 51,
  status: 'Under Review',
  submissionDate: '2023-05-31',
  eligibility: 'Needs Review',
  universityId: 5
}, {
  id: 417,
  studentName: 'Nawal Al Hosany',
  program: 'Executive MBA',
  programId: 52,
  status: 'Rejected',
  submissionDate: '2023-05-30',
  eligibility: 'Ineligible',
  universityId: 5
}, {
  id: 418,
  studentName: 'Khalfan Al Mazrouei',
  program: 'Bachelor of International Business',
  programId: 53,
  status: 'Pending',
  submissionDate: '2023-05-29',
  eligibility: 'Eligible',
  universityId: 5
}, {
  id: 419,
  studentName: 'Amina Al Rustamani',
  program: 'Master of Project Management',
  programId: 54,
  status: 'Accepted',
  submissionDate: '2023-05-28',
  eligibility: 'Eligible',
  universityId: 5
}, {
  id: 420,
  studentName: 'Abdulfattah Al Sharaf',
  program: 'PhD in Business Management',
  programId: 55,
  status: 'Under Review',
  submissionDate: '2023-05-27',
  eligibility: 'Needs Review',
  universityId: 5
}, {
  id: 421,
  studentName: 'Aisha Al Mulla',
  program: 'Master of Business Administration',
  programId: 46,
  status: 'Pending',
  submissionDate: '2023-05-26',
  eligibility: 'Eligible',
  universityId: 5
}, {
  id: 422,
  studentName: 'Hamad Al Shamsi',
  program: 'Bachelor of Business Management',
  programId: 47,
  status: 'Rejected',
  submissionDate: '2023-05-25',
  eligibility: 'Ineligible',
  universityId: 5
}, {
  id: 423,
  studentName: 'Noor Al Suwaidi',
  program: 'Master of Finance',
  programId: 48,
  status: 'Accepted',
  submissionDate: '2023-05-24',
  eligibility: 'Eligible',
  universityId: 5
}, {
  id: 424,
  studentName: 'Zaid Al Qasimi',
  program: 'Bachelor of Marketing',
  programId: 49,
  status: 'Under Review',
  submissionDate: '2023-05-23',
  eligibility: 'Needs Review',
  universityId: 5
}, {
  id: 425,
  studentName: 'Sheikha Al Nahyan',
  program: 'Master of Human Resources Management',
  programId: 50,
  status: 'Pending',
  submissionDate: '2023-05-22',
  eligibility: 'Eligible',
  universityId: 5
}, {
  id: 426,
  studentName: 'Rashid Al Dhaheri',
  program: 'Bachelor of Accounting',
  programId: 51,
  status: 'Accepted',
  submissionDate: '2023-05-21',
  eligibility: 'Eligible',
  universityId: 5
}, {
  id: 427,
  studentName: 'Manal Al Bayat',
  program: 'Executive MBA',
  programId: 52,
  status: 'Under Review',
  submissionDate: '2023-05-20',
  eligibility: 'Needs Review',
  universityId: 5
}, {
  id: 428,
  studentName: 'Omar Al Futtaim',
  program: 'Bachelor of International Business',
  programId: 53,
  status: 'Rejected',
  submissionDate: '2023-05-19',
  eligibility: 'Ineligible',
  universityId: 5
}, {
  id: 429,
  studentName: 'Rafia Al Abbar',
  program: 'Master of Project Management',
  programId: 54,
  status: 'Pending',
  submissionDate: '2023-05-18',
  eligibility: 'Eligible',
  universityId: 5
}, {
  id: 430,
  studentName: 'Khalid Al Malik',
  program: 'PhD in Business Management',
  programId: 55,
  status: 'Accepted',
  submissionDate: '2023-05-17',
  eligibility: 'Eligible',
  universityId: 5
}, {
  id: 431,
  studentName: 'Muna Al Kindi',
  program: 'Master of Business Administration',
  programId: 46,
  status: 'Under Review',
  submissionDate: '2023-05-16',
  eligibility: 'Needs Review',
  universityId: 5
}, {
  id: 432,
  studentName: 'Abdulla Al Ghurair',
  program: 'Bachelor of Business Management',
  programId: 47,
  status: 'Pending',
  submissionDate: '2023-05-15',
  eligibility: 'Eligible',
  universityId: 5
}, {
  id: 433,
  studentName: 'Hayat Al Fahim',
  program: 'Master of Finance',
  programId: 48,
  status: 'Rejected',
  submissionDate: '2023-05-14',
  eligibility: 'Ineligible',
  universityId: 5
}, {
  id: 434,
  studentName: 'Yousif Al Serkal',
  program: 'Bachelor of Marketing',
  programId: 49,
  status: 'Accepted',
  submissionDate: '2023-05-13',
  eligibility: 'Eligible',
  universityId: 5
}, {
  id: 435,
  studentName: 'Laila Al Yousuf',
  program: 'Master of Human Resources Management',
  programId: 50,
  status: 'Under Review',
  submissionDate: '2023-05-12',
  eligibility: 'Needs Review',
  universityId: 5
}, {
  id: 436,
  studentName: 'Saif Al Aleeli',
  program: 'Bachelor of Accounting',
  programId: 51,
  status: 'Pending',
  submissionDate: '2023-05-11',
  eligibility: 'Eligible',
  universityId: 5
}, {
  id: 437,
  studentName: 'Hala Al Gergawi',
  program: 'Executive MBA',
  programId: 52,
  status: 'Accepted',
  submissionDate: '2023-05-10',
  eligibility: 'Eligible',
  universityId: 5
}, {
  id: 438,
  studentName: 'Majid Al Mualla',
  program: 'Bachelor of International Business',
  programId: 53,
  status: 'Rejected',
  submissionDate: '2023-05-09',
  eligibility: 'Ineligible',
  universityId: 5
}, {
  id: 439,
  studentName: 'Budoor Al Raqbani',
  program: 'Master of Project Management',
  programId: 54,
  status: 'Under Review',
  submissionDate: '2023-05-08',
  eligibility: 'Needs Review',
  universityId: 5
}, {
  id: 440,
  studentName: 'Tariq Al Gurg',
  program: 'PhD in Business Management',
  programId: 55,
  status: 'Pending',
  submissionDate: '2023-05-07',
  eligibility: 'Eligible',
  universityId: 5
}, {
  id: 441,
  studentName: 'Najla Al Awadhi',
  program: 'Master of Business Administration',
  programId: 46,
  status: 'Accepted',
  submissionDate: '2023-05-06',
  eligibility: 'Eligible',
  universityId: 5
}, {
  id: 442,
  studentName: 'Jassim Al Bastaki',
  program: 'Bachelor of Business Management',
  programId: 47,
  status: 'Under Review',
  submissionDate: '2023-05-05',
  eligibility: 'Needs Review',
  universityId: 5
}, {
  id: 443,
  studentName: 'Ayesha Al Kaabi',
  program: 'Master of Finance',
  programId: 48,
  status: 'Pending',
  submissionDate: '2023-05-04',
  eligibility: 'Eligible',
  universityId: 5
}, {
  id: 444,
  studentName: 'Sami Al Qamzi',
  program: 'Bachelor of Marketing',
  programId: 49,
  status: 'Rejected',
  submissionDate: '2023-05-03',
  eligibility: 'Ineligible',
  universityId: 5
}, {
  id: 445,
  studentName: 'Iman Al Madani',
  program: 'Master of Human Resources Management',
  programId: 50,
  status: 'Accepted',
  submissionDate: '2023-05-02',
  eligibility: 'Eligible',
  universityId: 5
}, {
  id: 446,
  studentName: 'Nasser Al Neyadi',
  program: 'Bachelor of Accounting',
  programId: 51,
  status: 'Under Review',
  submissionDate: '2023-05-01',
  eligibility: 'Needs Review',
  universityId: 5
}, {
  id: 447,
  studentName: 'Khadija Al Bastaki',
  program: 'Executive MBA',
  programId: 52,
  status: 'Pending',
  submissionDate: '2023-04-30',
  eligibility: 'Eligible',
  universityId: 5
}, {
  id: 448,
  studentName: 'Fahad Al Shirawi',
  program: 'Bachelor of International Business',
  programId: 53,
  status: 'Accepted',
  submissionDate: '2023-04-29',
  eligibility: 'Eligible',
  universityId: 5
}, {
  id: 449,
  studentName: 'Shaikha Al Nowais',
  program: 'Master of Project Management',
  programId: 54,
  status: 'Rejected',
  submissionDate: '2023-04-28',
  eligibility: 'Ineligible',
  universityId: 5
}, {
  id: 450,
  studentName: 'Marwan Al Sarkal',
  program: 'PhD in Business Management',
  programId: 55,
  status: 'Pending',
  submissionDate: '2023-04-27',
  eligibility: 'Eligible',
  universityId: 5
}];
// University Status Badge Component
const StatusBadge = ({
  status
}) => {
  const getStatusColor = () => {
    switch (status) {
      case 'Active':
        return 'bg-green-100 text-green-800';
      case 'Under Review':
        return 'bg-yellow-100 text-yellow-800';
      case 'Inactive':
        return 'bg-red-100 text-red-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  };
  return <span className={`px-2.5 py-0.5 rounded-full text-xs font-medium ${getStatusColor()}`} data-id="element-2093">
      {status}
    </span>;
};
// Health Score Component
const HealthScore = ({
  score
}) => {
  const getBarColor = () => {
    if (score >= 90) return 'bg-green-500';
    if (score >= 80) return 'bg-blue-500';
    if (score >= 70) return 'bg-yellow-500';
    return 'bg-red-500';
  };
  const getTextColor = () => {
    if (score >= 90) return 'text-green-600';
    if (score >= 80) return 'text-blue-600';
    if (score >= 70) return 'text-yellow-600';
    return 'text-red-600';
  };
  const barColorClass = getBarColor();
  const textColorClass = getTextColor();
  const barWidth = `${score}%`;
  return <div className="flex items-center" data-id="element-2094">
      <div className="w-16 h-2 bg-gray-200 rounded-full overflow-hidden mr-2" data-id="element-2095">
        <div className={`h-full ${barColorClass}`} style={{
        width: barWidth
      }} data-id="element-2096"></div>
      </div>
      <span className={`text-sm font-medium ${textColorClass}`} data-id="element-2097">{score}</span>
    </div>;
};
// Trend Indicator Component
const TrendIndicator = ({
  trend
}) => {
  const isPositive = trend.startsWith('+');
  return <span className={`inline-flex items-center ${isPositive ? 'text-green-600' : 'text-red-600'}`} data-id="element-2098">
      {isPositive ? <TrendingUpIcon className="w-4 h-4 mr-1" data-id="element-2099" /> : <TrendingUpIcon className="w-4 h-4 mr-1 transform rotate-180" data-id="element-2100" />}
      {trend}
    </span>;
};
// Skill Gap Indicator Component
const SkillGapIndicator = ({
  gap
}) => {
  const getGapColor = () => {
    switch (gap) {
      case 'Critical':
        return 'bg-red-100 text-red-800 border-red-200';
      case 'High':
        return 'bg-orange-100 text-orange-800 border-orange-200';
      case 'Medium':
        return 'bg-yellow-100 text-yellow-800 border-yellow-200';
      case 'Low':
        return 'bg-green-100 text-green-800 border-green-200';
      default:
        return 'bg-gray-100 text-gray-800 border-gray-200';
    }
  };
  return <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${getGapColor()}`} data-id="element-2101">
      {gap}
    </span>;
};
// Application Status Badge Component
const ApplicationStatusBadge = ({
  status
}) => {
  const getStatusColor = () => {
    switch (status) {
      case 'Accepted':
        return 'bg-green-100 text-green-800';
      case 'Rejected':
        return 'bg-red-100 text-red-800';
      case 'Pending':
        return 'bg-yellow-100 text-yellow-800';
      case 'Under Review':
        return 'bg-blue-100 text-blue-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  };
  return <span className={`px-2.5 py-0.5 rounded-full text-xs font-medium ${getStatusColor()}`} data-id="element-2102">
      {status}
    </span>;
};
// Eligibility Badge Component
const EligibilityBadge = ({
  eligibility
}) => {
  const getEligibilityColor = () => {
    switch (eligibility) {
      case 'Eligible':
        return 'bg-green-100 text-green-800';
      case 'Ineligible':
        return 'bg-red-100 text-red-800';
      case 'Needs Review':
        return 'bg-yellow-100 text-yellow-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  };
  return <span className={`px-2.5 py-0.5 rounded-full text-xs font-medium ${getEligibilityColor()}`} data-id="element-2103">
      {eligibility}
    </span>;
};
// AI Insight Card Component
const AIInsightCard = ({
  insight
}) => {
  const getInsightStyles = () => {
    switch (insight.severity) {
      case 'high':
        return {
          bg: 'bg-red-50',
          border: 'border-red-100',
          text: 'text-red-800',
          icon: <AlertCircleIcon className="w-5 h-5 text-red-500" data-id="element-2104" />
        };
      case 'medium':
        return {
          bg: 'bg-yellow-50',
          border: 'border-yellow-100',
          text: 'text-yellow-800',
          icon: <AlertCircleIcon className="w-5 h-5 text-yellow-500" data-id="element-2105" />
        };
      case 'positive':
        return {
          bg: 'bg-green-50',
          border: 'border-green-100',
          text: 'text-green-800',
          icon: <TrendingUpIcon className="w-5 h-5 text-green-500" data-id="element-2106" />
        };
      default:
        return {
          bg: 'bg-blue-50',
          border: 'border-blue-100',
          text: 'text-blue-800',
          icon: <SparklesIcon className="w-5 h-5 text-blue-500" data-id="element-2107" />
        };
    }
  };
  const styles = getInsightStyles();
  return <div className={`p-4 rounded-lg ${styles.bg} border ${styles.border} mb-4`} data-id="element-2108">
      <div className="flex items-start" data-id="element-2109">
        <div className="flex-shrink-0 mt-0.5" data-id="element-2110">{styles.icon}</div>
        <div className="ml-3" data-id="element-2111">
          <h3 className={`text-sm font-medium ${styles.text}`} data-id="element-2112">
            {insight.title}
          </h3>
          <p className={`mt-1 text-sm ${styles.text} opacity-90`} data-id="element-2113">
            {insight.message}
          </p>
        </div>
      </div>
    </div>;
};
// Custom tooltip for charts
const CustomTooltip = ({
  active,
  payload,
  label
}) => {
  if (active && payload && payload.length) {
    return <div className="bg-white p-2 border border-gray-200 shadow-sm rounded-md" data-id="element-2114">
        <p className="text-sm font-medium" data-id="element-2115">{label}</p>
        {payload.map((entry, index) => <p key={index} className="text-sm" style={{
        color: entry.color
      }} data-id="element-2116">
            {entry.name}: {entry.value}
          </p>)}
      </div>;
  }
  return null;
};
const UniversityDetail = () => {
  const {
    universityId
  } = useParams();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('programs');
  const [university, setUniversity] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [programFilter, setProgramFilter] = useState('all');
  const [applicationFilter, setApplicationFilter] = useState('all');
  const [searchQuery, setSearchQuery] = useState('');
  useEffect(() => {
    // In a real app, this would be an API call
    const fetchUniversity = () => {
      setIsLoading(true);
      try {
        const foundUniversity = universitiesData.find(u => u.id === parseInt(universityId));
        if (foundUniversity) {
          setUniversity(foundUniversity);
        } else {
          // Handle not found
          console.error('University not found');
        }
      } catch (err) {
        console.error('Error fetching university:', err);
      } finally {
        setIsLoading(false);
      }
    };
    fetchUniversity();
  }, [universityId]);
  // Filter programs for this university
  const universityPrograms = programsData.filter(program => program.universityId === parseInt(universityId));
  // Filter applications for this university
  const universityApplications = applicationsData.filter(app => app.universityId === parseInt(universityId));
  // Filter programs based on selected filter and search query
  const filteredPrograms = universityPrograms.filter(program => program.name.toLowerCase().includes(searchQuery.toLowerCase()) || program.type.toLowerCase().includes(searchQuery.toLowerCase())).filter(program => programFilter === 'all' ? true : program.status.toLowerCase() === programFilter.toLowerCase());
  // Filter applications based on selected filter and search query
  const filteredApplications = universityApplications.filter(app => app.studentName.toLowerCase().includes(searchQuery.toLowerCase()) || app.program.toLowerCase().includes(searchQuery.toLowerCase())).filter(app => applicationFilter === 'all' ? true : app.status.toLowerCase() === applicationFilter.toLowerCase());
  if (isLoading) {
    return <Layout title="University Details" persona="Platform Admin" data-id="element-2117">
        <div className="flex justify-center items-center h-64" data-id="element-2118">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-500" data-id="element-2119"></div>
        </div>
      </Layout>;
  }
  if (!university) {
    return <Layout title="University Details" persona="Platform Admin" data-id="element-2120">
        <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded relative" role="alert" data-id="element-2121">
          <strong className="font-bold" data-id="element-2122">Error: </strong>
          <span className="block sm:inline" data-id="element-2123">University not found</span>
        </div>
      </Layout>;
  }
  return <Layout title={university.name} persona="Platform Admin" data-id="element-2124">
      {/* Back button */}
      <div className="mb-4" data-id="element-2125"></div>
      {/* University Header */}
      <div className="bg-white rounded-lg border border-gray-200 shadow-sm mb-6 overflow-hidden" data-id="element-2126">
        <div className="p-6" data-id="element-2127">
          <div className="flex flex-col md:flex-row md:items-center justify-between mb-6" data-id="element-2128">
            <div className="flex items-center mb-4 md:mb-0" data-id="element-2129">
              <div className="h-16 w-16 rounded-full bg-primary-100 text-primary-600 flex items-center justify-center mr-4" data-id="element-2130">
                <BuildingIcon className="h-8 w-8" data-id="element-2131" />
              </div>
              <div data-id="element-2132">
                <div className="flex items-center" data-id="element-2133">
                  <StatusBadge status={university.status} data-id="element-2134" />
                  <span className="mx-2 text-gray-400" data-id="element-2135">•</span>
                  <div className="flex items-center text-gray-600" data-id="element-2136">
                    <MapPinIcon className="w-4 h-4 mr-1" data-id="element-2137" />
                    {university.location}
                  </div>
                  <span className="mx-2 text-gray-400" data-id="element-2138">•</span>
                  <div className="text-gray-600" data-id="element-2139">
                    Est. {university.establishedYear}
                  </div>
                </div>
                <h1 className="text-2xl font-semibold text-gray-900 mt-1" data-id="element-2140">
                  {university.name}
                </h1>
                <div className="flex items-center mt-1" data-id="element-2141">
                  <GlobeIcon className="h-4 w-4 text-gray-500 mr-1" data-id="element-2142" />
                  <a href={`https://${university.website}`} target="_blank" rel="noopener noreferrer" className="text-primary-600 hover:underline" data-id="element-2143">
                    {university.website}
                  </a>
                </div>
              </div>
            </div>
            <div className="flex space-x-2" data-id="element-2144">
              <button className="px-4 py-2 bg-primary-500 text-white rounded-md text-sm font-medium hover:bg-primary-600" data-id="element-2145">
                <MailIcon className="w-4 h-4 mr-1 inline" data-id="element-2146" />
                Contact
              </button>
              <button className="px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 hover:bg-gray-50" data-id="element-2147">
                <DownloadIcon className="w-4 h-4 mr-1 inline" data-id="element-2148" />
                Export Data
              </button>
            </div>
          </div>
          {/* KPI Cards */}
          <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6" data-id="element-2149">
            <div className="bg-gray-50 p-4 rounded-lg" data-id="element-2150">
              <div className="flex items-center justify-between mb-2" data-id="element-2151">
                <div className="text-sm text-gray-500" data-id="element-2152">Programs</div>
                <GraduationCapIcon className="h-5 w-5 text-primary-500" data-id="element-2153" />
              </div>
              <div className="text-2xl font-semibold" data-id="element-2154">
                {university.programs}
              </div>
              <div className="mt-1 text-xs text-gray-500" data-id="element-2155">
                Last updated: {university.lastUpdated}
              </div>
            </div>
            <div className="bg-gray-50 p-4 rounded-lg" data-id="element-2156">
              <div className="flex items-center justify-between mb-2" data-id="element-2157">
                <div className="text-sm text-gray-500" data-id="element-2158">Applications</div>
                <UsersIcon className="h-5 w-5 text-primary-500" data-id="element-2159" />
              </div>
              <div className="text-2xl font-semibold" data-id="element-2160">
                {university.activeApplications}
              </div>
              <div className="mt-1 text-xs text-gray-500" data-id="element-2161">
                {university.pendingReviews} pending reviews
              </div>
            </div>
            <div className="bg-gray-50 p-4 rounded-lg" data-id="element-2162">
              <div className="flex items-center justify-between mb-2" data-id="element-2163">
                <div className="text-sm text-gray-500" data-id="element-2164">Students</div>
                <UsersIcon className="h-5 w-5 text-primary-500" data-id="element-2165" />
              </div>
              <div className="text-2xl font-semibold" data-id="element-2166">
                {university.studentsEnrolled.toLocaleString()}
              </div>
              <div className="mt-1 text-xs text-gray-500" data-id="element-2167">
                Currently enrolled
              </div>
            </div>
            <div className="bg-gray-50 p-4 rounded-lg" data-id="element-2168">
              <div className="flex items-center justify-between mb-2" data-id="element-2169">
                <div className="text-sm text-gray-500" data-id="element-2170">Health Score</div>
                <BarChart3Icon className="h-5 w-5 text-primary-500" data-id="element-2171" />
              </div>
              <div className="text-2xl font-semibold flex items-center" data-id="element-2172">
                <HealthScore score={university.healthScore} data-id="element-2173" />
              </div>
              <div className="mt-1 text-xs text-gray-500" data-id="element-2174">
                +2 from last quarter
              </div>
            </div>
          </div>
          {/* Contact Information */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6" data-id="element-2175">
            <div className="border border-gray-200 rounded-lg p-4" data-id="element-2176">
              <div className="text-sm font-medium text-gray-500 mb-2" data-id="element-2177">
                Primary Contact
              </div>
              <div className="font-medium" data-id="element-2178">
                {university.contacts.primary.name}
              </div>
              <div className="text-sm text-gray-600" data-id="element-2179">
                {university.contacts.primary.title}
              </div>
              <div className="mt-2 flex flex-col space-y-1" data-id="element-2180">
                <div className="flex items-center text-sm" data-id="element-2181">
                  <MailIcon className="w-4 h-4 text-gray-400 mr-2" data-id="element-2182" />
                  <a href={`mailto:${university.contacts.primary.email}`} className="text-primary-600 hover:underline" data-id="element-2183">
                    {university.contacts.primary.email}
                  </a>
                </div>
                <div className="flex items-center text-sm" data-id="element-2184">
                  <PhoneIcon className="w-4 h-4 text-gray-400 mr-2" data-id="element-2185" />
                  <span data-id="element-2186">{university.contacts.primary.phone}</span>
                </div>
              </div>
            </div>
            <div className="border border-gray-200 rounded-lg p-4" data-id="element-2187">
              <div className="text-sm font-medium text-gray-500 mb-2" data-id="element-2188">
                Secondary Contact
              </div>
              <div className="font-medium" data-id="element-2189">
                {university.contacts.secondary.name}
              </div>
              <div className="text-sm text-gray-600" data-id="element-2190">
                {university.contacts.secondary.title}
              </div>
              <div className="mt-2 flex flex-col space-y-1" data-id="element-2191">
                <div className="flex items-center text-sm" data-id="element-2192">
                  <MailIcon className="w-4 h-4 text-gray-400 mr-2" data-id="element-2193" />
                  <a href={`mailto:${university.contacts.secondary.email}`} className="text-primary-600 hover:underline" data-id="element-2194">
                    {university.contacts.secondary.email}
                  </a>
                </div>
                <div className="flex items-center text-sm" data-id="element-2195">
                  <PhoneIcon className="w-4 h-4 text-gray-400 mr-2" data-id="element-2196" />
                  <span data-id="element-2197">{university.contacts.secondary.phone}</span>
                </div>
              </div>
            </div>
          </div>
          {/* AI Insights */}
          <div className="mb-6" data-id="element-2198">
            <h2 className="text-lg font-medium text-gray-800 mb-4 flex items-center" data-id="element-2199">
              <SparklesIcon className="w-5 h-5 mr-2 text-primary-500" data-id="element-2200" />
              AI Insights
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-2201">
              {university.aiInsights.map((insight, index) => <AIInsightCard key={index} insight={insight} data-id="element-2202" />)}
            </div>
          </div>
          {/* Tab Navigation */}
          <div className="border-b border-gray-200" data-id="element-2203">
            <nav className="-mb-px flex space-x-8" data-id="element-2204">
              <button onClick={() => setActiveTab('programs')} className={`py-4 px-1 border-b-2 font-medium text-sm ${activeTab === 'programs' ? 'border-primary-500 text-primary-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} data-id="element-2205">
                Programs
              </button>
              <button onClick={() => setActiveTab('applications')} className={`py-4 px-1 border-b-2 font-medium text-sm ${activeTab === 'applications' ? 'border-primary-500 text-primary-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} data-id="element-2206">
                Applications
              </button>
              <button onClick={() => setActiveTab('healthTrends')} className={`py-4 px-1 border-b-2 font-medium text-sm ${activeTab === 'healthTrends' ? 'border-primary-500 text-primary-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} data-id="element-2207">
                Health Trends
              </button>
              <button onClick={() => setActiveTab('accreditation')} className={`py-4 px-1 border-b-2 font-medium text-sm ${activeTab === 'accreditation' ? 'border-primary-500 text-primary-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} data-id="element-2208">
                Accreditation
              </button>
            </nav>
          </div>
        </div>
        {/* Tab Content */}
        <div className="p-6 bg-gray-50" data-id="element-2209">
          {activeTab === 'programs' && <div data-id="element-2210">
              <div className="flex flex-wrap justify-between items-center mb-6" data-id="element-2211">
                <h2 className="text-lg font-medium text-gray-800" data-id="element-2212">
                  Programs ({filteredPrograms.length})
                </h2>
                <div className="flex flex-wrap items-center gap-3 mt-3 md:mt-0" data-id="element-2213">
                  {/* Search Input */}
                  <div className="relative" data-id="element-2214">
                    <input type="text" placeholder="Search programs..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} className="pl-9 pr-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent" data-id="element-2215" />
                    <SearchIcon className="absolute left-3 top-2.5 w-4 h-4 text-gray-400" data-id="element-2216" />
                  </div>
                  {/* Status Filter */}
                  <div className="relative" data-id="element-2217">
                    <select value={programFilter} onChange={e => setProgramFilter(e.target.value)} className="pl-3 pr-8 py-2 border border-gray-300 rounded-md bg-white text-sm text-gray-700 appearance-none focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent" data-id="element-2218">
                      <option value="all" data-id="element-2219">All Programs</option>
                      <option value="active" data-id="element-2220">Active</option>
                      <option value="under review" data-id="element-2221">Under Review</option>
                    </select>
                    <ChevronDownIcon className="absolute right-3 top-2.5 w-4 h-4 text-gray-500 pointer-events-none" data-id="element-2222" />
                  </div>
                  
                </div>
              </div>
              {/* Programs Table */}
              <div className="bg-white rounded-lg border border-gray-200 overflow-hidden" data-id="element-2223">
                <div className="overflow-x-auto" data-id="element-2224">
                  <table className="min-w-full divide-y divide-gray-200" data-id="element-2225">
                    <thead className="bg-gray-50" data-id="element-2226">
                      <tr data-id="element-2227">
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2228">
                          Program
                        </th>
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2229">
                          Type
                        </th>
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2230">
                          Applications
                        </th>
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2231">
                          Trend
                        </th>
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2232">
                          Skill Gap
                        </th>
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2233">
                          Status
                        </th>
                        <th scope="col" className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2234">
                          Actions
                        </th>
                      </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200" data-id="element-2235">
                      {filteredPrograms.map(program => <tr key={program.id} className="hover:bg-gray-50" data-id="element-2236">
                          <td className="px-6 py-4 whitespace-nowrap" data-id="element-2237">
                            <div className="text-sm font-medium text-gray-900" data-id="element-2238">
                              {program.name}
                            </div>
                            <div className="text-sm text-gray-500" data-id="element-2239">
                              Last updated: {program.lastUpdated}
                            </div>
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap" data-id="element-2240">
                            <div className="text-sm text-gray-900" data-id="element-2241">
                              {program.type}
                            </div>
                            <div className="text-sm text-gray-500" data-id="element-2242">
                              {program.duration}
                            </div>
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap" data-id="element-2243">
                            <div className="text-sm text-gray-900" data-id="element-2244">
                              {program.applications}
                            </div>
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap" data-id="element-2245">
                            <TrendIndicator trend={program.trend} data-id="element-2246" />
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap" data-id="element-2247">
                            <SkillGapIndicator gap={program.skillGap} data-id="element-2248" />
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap" data-id="element-2249">
                            <StatusBadge status={program.status} data-id="element-2250" />
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium" data-id="element-2251">
                            <button onClick={() => navigate(`/admin/programs/${program.id}`)} className="text-primary-600 hover:text-primary-900" data-id="element-2252">
                              View Details
                            </button>
                          </td>
                        </tr>)}
                    </tbody>
                  </table>
                </div>
                {filteredPrograms.length === 0 && <div className="text-center py-8" data-id="element-2253">
                    <GraduationCapIcon className="mx-auto h-12 w-12 text-gray-300" data-id="element-2254" />
                    <h3 className="mt-2 text-sm font-medium text-gray-900" data-id="element-2255">
                      No programs found
                    </h3>
                    <p className="mt-1 text-sm text-gray-500" data-id="element-2256">
                      Try adjusting your filter criteria
                    </p>
                  </div>}
              </div>
            </div>}
          {activeTab === 'applications' && <div data-id="element-2257">
              <div className="flex flex-wrap justify-between items-center mb-6" data-id="element-2258">
                <h2 className="text-lg font-medium text-gray-800" data-id="element-2259">
                  Applications ({filteredApplications.length})
                </h2>
                <div className="flex flex-wrap items-center gap-3 mt-3 md:mt-0" data-id="element-2260">
                  {/* Search Input */}
                  <div className="relative" data-id="element-2261">
                    <input type="text" placeholder="Search applications..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} className="pl-9 pr-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent" data-id="element-2262" />
                    <SearchIcon className="absolute left-3 top-2.5 w-4 h-4 text-gray-400" data-id="element-2263" />
                  </div>
                  {/* Status Filter */}
                  <div className="relative" data-id="element-2264">
                    <select value={applicationFilter} onChange={e => setApplicationFilter(e.target.value)} className="pl-3 pr-8 py-2 border border-gray-300 rounded-md bg-white text-sm text-gray-700 appearance-none focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent" data-id="element-2265">
                      <option value="all" data-id="element-2266">All Applications</option>
                      <option value="pending" data-id="element-2267">Pending</option>
                      <option value="under review" data-id="element-2268">Under Review</option>
                      <option value="accepted" data-id="element-2269">Accepted</option>
                      <option value="rejected" data-id="element-2270">Rejected</option>
                    </select>
                    <ChevronDownIcon className="absolute right-3 top-2.5 w-4 h-4 text-gray-500 pointer-events-none" data-id="element-2271" />
                  </div>
                  
                </div>
              </div>
              {/* Applications Table */}
              <div className="bg-white rounded-lg border border-gray-200 overflow-hidden" data-id="element-2272">
                <div className="overflow-x-auto" data-id="element-2273">
                  <table className="min-w-full divide-y divide-gray-200" data-id="element-2274">
                    <thead className="bg-gray-50" data-id="element-2275">
                      <tr data-id="element-2276">
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2277">
                          Student
                        </th>
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2278">
                          Program
                        </th>
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2279">
                          Submission Date
                        </th>
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2280">
                          Eligibility
                        </th>
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2281">
                          Status
                        </th>
                        <th scope="col" className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2282">
                          Actions
                        </th>
                      </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200" data-id="element-2283">
                      {filteredApplications.map(application => <tr key={application.id} className="hover:bg-gray-50" data-id="element-2284">
                          <td className="px-6 py-4 whitespace-nowrap" data-id="element-2285">
                            <div className="flex items-center" data-id="element-2286">
                              <div className="flex-shrink-0 h-10 w-10 rounded-full bg-primary-100 text-primary-600 flex items-center justify-center" data-id="element-2287">
                                {application.studentName.split(' ').map(n => n[0]).join('')}
                              </div>
                              <div className="ml-4" data-id="element-2288">
                                <div className="text-sm font-medium text-gray-900" data-id="element-2289">
                                  {application.studentName}
                                </div>
                                <div className="text-sm text-gray-500" data-id="element-2290">
                                  ID: STU-{application.id}
                                </div>
                              </div>
                            </div>
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap" data-id="element-2291">
                            <div className="text-sm text-gray-900" data-id="element-2292">
                              {application.program}
                            </div>
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap" data-id="element-2293">
                            <div className="text-sm text-gray-900" data-id="element-2294">
                              {application.submissionDate}
                            </div>
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap" data-id="element-2295">
                            <EligibilityBadge eligibility={application.eligibility} data-id="element-2296" />
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap" data-id="element-2297">
                            <ApplicationStatusBadge status={application.status} data-id="element-2298" />
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium" data-id="element-2299">
                            <button className="text-primary-600 hover:text-primary-900" data-id="element-2300">
                              View Details
                            </button>
                          </td>
                        </tr>)}
                    </tbody>
                  </table>
                </div>
                {filteredApplications.length === 0 && <div className="text-center py-8" data-id="element-2301">
                    <UsersIcon className="mx-auto h-12 w-12 text-gray-300" data-id="element-2302" />
                    <h3 className="mt-2 text-sm font-medium text-gray-900" data-id="element-2303">
                      No applications found
                    </h3>
                    <p className="mt-1 text-sm text-gray-500" data-id="element-2304">
                      Try adjusting your filter criteria
                    </p>
                  </div>}
              </div>
            </div>}
          {activeTab === 'healthTrends' && <div data-id="element-2305">
              <h2 className="text-lg font-medium text-gray-800 mb-6" data-id="element-2306">
                Health Trends
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6" data-id="element-2307">
                {/* Application Trends Chart */}
                <div className="bg-white p-4 rounded-lg border border-gray-200" data-id="element-2308">
                  <h3 className="text-md font-medium text-gray-700 mb-4" data-id="element-2309">
                    Application Volume (Last 6 Months)
                  </h3>
                  <div className="h-64" data-id="element-2310">
                    <ResponsiveContainer width="100%" height="100%" data-id="element-2311">
                      <LineChart data={university.applicationTrends} margin={{
                    top: 5,
                    right: 30,
                    left: 20,
                    bottom: 5
                  }} data-id="element-2312">
                        <CartesianGrid strokeDasharray="3 3" data-id="element-2313" />
                        <XAxis dataKey="month" data-id="element-2314" />
                        <YAxis data-id="element-2315" />
                        <Tooltip content={<CustomTooltip data-id="element-2317" />} data-id="element-2316" />
                        <Line type="monotone" dataKey="applications" name="Applications" stroke="#043C5B" strokeWidth={2} activeDot={{
                      r: 8
                    }} data-id="element-2318" />
                      </LineChart>
                    </ResponsiveContainer>
                  </div>
                </div>
                {/* Health Score History Chart */}
                <div className="bg-white p-4 rounded-lg border border-gray-200" data-id="element-2319">
                  <h3 className="text-md font-medium text-gray-700 mb-4" data-id="element-2320">
                    Health Score History
                  </h3>
                  <div className="h-64" data-id="element-2321">
                    <ResponsiveContainer width="100%" height="100%" data-id="element-2322">
                      <LineChart data={university.healthScoreHistory} margin={{
                    top: 5,
                    right: 30,
                    left: 20,
                    bottom: 5
                  }} data-id="element-2323">
                        <CartesianGrid strokeDasharray="3 3" data-id="element-2324" />
                        <XAxis dataKey="quarter" data-id="element-2325" />
                        <YAxis domain={[70, 100]} data-id="element-2326" />
                        <Tooltip content={<CustomTooltip data-id="element-2328" />} data-id="element-2327" />
                        <Line type="monotone" dataKey="score" name="Health Score" stroke="#10B981" strokeWidth={2} activeDot={{
                      r: 8
                    }} data-id="element-2329" />
                      </LineChart>
                    </ResponsiveContainer>
                  </div>
                </div>
              </div>
              {/* Health Metrics */}
              <div className="bg-white p-6 rounded-lg border border-gray-200" data-id="element-2330">
                <h3 className="text-md font-medium text-gray-700 mb-4" data-id="element-2331">
                  Health Metrics
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-2332">
                  <div className="border border-gray-200 rounded-lg p-4" data-id="element-2333">
                    <div className="flex items-center justify-between mb-2" data-id="element-2334">
                      <div className="text-sm font-medium text-gray-500" data-id="element-2335">
                        Application Completion Rate
                      </div>
                      <div className="text-green-600 font-medium text-sm" data-id="element-2336">
                        92%
                      </div>
                    </div>
                    <div className="w-full h-2 bg-gray-200 rounded-full overflow-hidden" data-id="element-2337">
                      <div className="h-full bg-green-500" style={{
                    width: '92%'
                  }} data-id="element-2338"></div>
                    </div>
                    <p className="mt-2 text-xs text-gray-500" data-id="element-2339">
                      Percentage of started applications that are completed and
                      submitted
                    </p>
                  </div>
                  <div className="border border-gray-200 rounded-lg p-4" data-id="element-2340">
                    <div className="flex items-center justify-between mb-2" data-id="element-2341">
                      <div className="text-sm font-medium text-gray-500" data-id="element-2342">
                        Student Retention Rate
                      </div>
                      <div className="text-blue-600 font-medium text-sm" data-id="element-2343">
                        85%
                      </div>
                    </div>
                    <div className="w-full h-2 bg-gray-200 rounded-full overflow-hidden" data-id="element-2344">
                      <div className="h-full bg-blue-500" style={{
                    width: '85%'
                  }} data-id="element-2345"></div>
                    </div>
                    <p className="mt-2 text-xs text-gray-500" data-id="element-2346">
                      Percentage of students who continue to the next academic
                      year
                    </p>
                  </div>
                  <div className="border border-gray-200 rounded-lg p-4" data-id="element-2347">
                    <div className="flex items-center justify-between mb-2" data-id="element-2348">
                      <div className="text-sm font-medium text-gray-500" data-id="element-2349">
                        Program Completion Rate
                      </div>
                      <div className="text-yellow-600 font-medium text-sm" data-id="element-2350">
                        78%
                      </div>
                    </div>
                    <div className="w-full h-2 bg-gray-200 rounded-full overflow-hidden" data-id="element-2351">
                      <div className="h-full bg-yellow-500" style={{
                    width: '78%'
                  }} data-id="element-2352"></div>
                    </div>
                    <p className="mt-2 text-xs text-gray-500" data-id="element-2353">
                      Percentage of students who complete their programs
                    </p>
                  </div>
                </div>
              </div>
            </div>}
          {activeTab === 'accreditation' && <div data-id="element-2354">
              <div className="flex flex-wrap justify-between items-center mb-6" data-id="element-2355">
                <h2 className="text-lg font-medium text-gray-800" data-id="element-2356">
                  Accreditation Information
                </h2>
                <button className="px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 hover:bg-gray-50" data-id="element-2357">
                  <DownloadIcon className="w-4 h-4 mr-1 inline" data-id="element-2358" />
                  Download Certificates
                </button>
              </div>
              {/* Current Accreditation Status */}
              <div className="bg-white p-6 rounded-lg border border-gray-200 mb-6" data-id="element-2359">
                <div className="flex items-start" data-id="element-2360">
                  <div className="flex-shrink-0" data-id="element-2361">
                    <div className="h-10 w-10 rounded-full bg-green-100 flex items-center justify-center" data-id="element-2362">
                      <ShieldIcon className="h-6 w-6 text-green-600" data-id="element-2363" />
                    </div>
                  </div>
                  <div className="ml-4" data-id="element-2364">
                    <h3 className="text-lg font-medium text-gray-900" data-id="element-2365">
                      Current Status: {university.accreditationStatus}
                    </h3>
                    <p className="text-gray-600 mt-1" data-id="element-2366">
                      Accredited by: {university.accreditation}
                    </p>
                    <div className="mt-2 flex items-center" data-id="element-2367">
                      <CalendarIcon className="h-4 w-4 text-gray-400 mr-1" data-id="element-2368" />
                      <span className="text-sm text-gray-500" data-id="element-2369">
                        Valid until: {university.accreditationExpiry}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              {/* Accreditation History */}
              <div className="bg-white rounded-lg border border-gray-200 overflow-hidden" data-id="element-2370">
                <div className="px-6 py-4 border-b border-gray-200 bg-gray-50" data-id="element-2371">
                  <h3 className="text-md font-medium text-gray-700" data-id="element-2372">
                    Accreditation History
                  </h3>
                </div>
                <div className="overflow-x-auto" data-id="element-2373">
                  <table className="min-w-full divide-y divide-gray-200" data-id="element-2374">
                    <thead className="bg-gray-50" data-id="element-2375">
                      <tr data-id="element-2376">
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2377">
                          Date
                        </th>
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2378">
                          Status
                        </th>
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2379">
                          Notes
                        </th>
                        <th scope="col" className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2380">
                          Documents
                        </th>
                      </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200" data-id="element-2381">
                      {university.accreditationHistory.map((record, index) => <tr key={index} className="hover:bg-gray-50" data-id="element-2382">
                          <td className="px-6 py-4 whitespace-nowrap" data-id="element-2383">
                            <div className="text-sm text-gray-900" data-id="element-2384">
                              {record.date}
                            </div>
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap" data-id="element-2385">
                            <span className={`px-2.5 py-0.5 rounded-full text-xs font-medium ${record.status === 'Fully Accredited' ? 'bg-green-100 text-green-800' : 'bg-yellow-100 text-yellow-800'}`} data-id="element-2386">
                              {record.status}
                            </span>
                          </td>
                          <td className="px-6 py-4" data-id="element-2387">
                            <div className="text-sm text-gray-900" data-id="element-2388">
                              {record.notes}
                            </div>
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium" data-id="element-2389">
                            <button className="text-primary-600 hover:text-primary-900" data-id="element-2390">
                              <FileTextIcon className="w-4 h-4 inline mr-1" data-id="element-2391" />
                              View
                            </button>
                          </td>
                        </tr>)}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>}
        </div>
      </div>
    </Layout>;
};
export default UniversityDetail;